import React, { useEffect, useRef, useState } from "react";
import confetti from "canvas-confetti";

import Collapsible from "react-collapsible";
import Countdown, { zeroPad } from "react-countdown";

import PortalModal from "./modal/PortalModal";

import Button from "./Button";
import Border from "./Border";

import LogoEditor from "./LogoEditor";

import Img, { getImageUrl, Sizes } from "../components/blocks/editable/Img";

import LinkSelect from "./LinkSelect";

import ColorPicker from "./ColorPicker";

import Backend from "../utils/Backend";
import General from "../utils/General";
import Currency from "../utils/Currency";
import Cart from "../utils/Cart";
import Notify from "../utils/Notify";
import Navigation from "../utils/Navigation";

import SmartList from "./common/SmartList";
import ActionToolbar from "./ActionToolbar.js";

import $ from "jquery";
import Event from "../utils/Event";
import AuthManager from "../utils/AuthManager";
import DefaultData from "../utils/DefaultData";
import Toggle from "./sectioninputs/Toggle";
import { IconAndSVGPicker } from "./IconPickerGrid";
import Dropdown from "./Dropdown";
import DeleteModal from "./modal/settings/DeleteModal";
import DrawerCartSettings from "./DrawerCartSettings";
import { findMatchingVariant, getIconType, getStandardIcon, getSVGIcon, updateIconType, updateIconValue, CART_DRAWER_BUTTON_COLOR_CONSTANTS, CART_DRAWER_SUB_AND_SAVE_CONSTANTS, CART_DRAWER_SLIDER_CONSTANTS, CART_DRAWER_RECOMMENDATIONS_STYLE_CONSTANTS, CART_DRAWER_STYLE_CONSTANTS, CART_DRAWER_PRODUCTS_STYLE_CONSTANTS } from "./constants/utils";
import SearchResults from "./SearchResults";
import AsyncSelect from "./common/CCAsyncSelect";
import { ssTags } from "./constants/utils";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import InsureshipWidget from "./InsureshipWidget.js";

let HAMBURGER_MENU_STYLES = [
  {
    value: "overlay",
    label: "Overlay"
  },
  {
    value: "dropdown",
    label: "Dropdown"
  },
]

const PROMO_BAR_POSITION = [
  {
    value: "above",
    label: "Above Header"
  },
  {
    value: "below",
    label: "Below Header"
  },
]

const PROMO_BAR_STYLES = [
  {
    value: "single",
    label: "Single"
  },
  {
    value: "rotate",
    label: "Rotate"
  },
  {
    value: "continuous",
    label: "Continuous"
  },
]

const PROMO_BAR_ROTATE_INTERVAL = [
  {
    value: 3000,
    label: "3 Seconds"
  },
  {
    value: 6000,
    label: "6 Seconds"
  },
  {
    value: 9000,
    label: "9 Seconds"
  },
  {
    value: 12000,
    label: "12 Seconds"
  },
  {
    value: 15000,
    label: "15 Seconds"
  },
]

const PROMO_BAR_ROTATE_ANIMATIONS = [
  {
    value: "fade-in",
    label: "Fade"
  },
  {
    value: "slide-fade-in",
    label: "Slide Up"
  },
  {
    value: "slide-fade-out",
    label: "Slide Down"
  },
  {
    value: "slide-fade-left",
    label: "Slide Left"
  },
  {
    value: "slide-fade-right",
    label: "Slide Right"
  },
  {
    value: "zoom-in",
    label: "Zoom"
  },
  {
    value: "flip-in-y",
    label: "Flip In Horizontally"
  },
  {
    value: "flip-in-x",
    label: "Flip In Vertically"
  },
]

const PROMO_BAR_CONTINUOUS_SPEED = [
  {
    value: 20,
    label: "20 seconds"
  },
  {
    value: 30,
    label: "30 seconds"
  },
  {
    value: 40,
    label: "40 seconds"
  },
  {
    value: 50,
    label: "50 seconds"
  },
  {
    value: 60,
    label: "60 seconds"
  },
]

const CART_ICON_ROUTES = [
  {
    value: "modal",
    label: "Cart Drawer"
  },
  {
    value: "page",
    label: "Cart Page"
  }
]

const DEFAULT_RECOMMENDATION_COUNT = 3;

const CanvasConfettiBox = () => {
  const canvasRef = useRef(null);
  const animationRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const myConfetti = confetti.create(canvas, { resize: true, useWorker: false });
    const end = Date.now() + 1000;
    const shoot = () => {
      myConfetti({
        particleCount: 5,
        scalar: 1.5,
        gravity: -0.6,
        origin: { y: 1.6 },
        spread: 90,
        startVelocity: 50,
        colors: ['#ffc800ff', '#FF0000', '#2E3192', '#41BBC7', '#8400ffff']
      });

      if (Date.now() < end) {
        animationRef.current = requestAnimationFrame(shoot);
      }
    };

    shoot();
    return () => cancelAnimationFrame(animationRef.current);
  }, []);

  return (
    <div style={{ position: 'relative', width: '100%', height: '100%' }}>
      <canvas
        ref={canvasRef}
        style={{
          position: 'absolute',
          width: '100%',
          height: '100vh',
          pointerEvents: 'none',
          transform: "rotate(3.142rad)"
        }}
      />
    </div>
  );
};

const stripSubsMarkers = (arr = []) =>
  arr.filter(s => !/^(__ss_|frequency\s*:)/i.test(String(s)));


export function getHsaBadge(product) {
    // 1. Check eligibility — if productTags key doesn't exist, returns null safely
    const isEligible = product?.productTags &&
        product.productTags.split(",").map(t => t.trim()).includes("hsa_fsa_eligible");
 
    if (!isEligible) return null;
 
    // 2. Try metafield badge — getProductBadgeData returns [] if metaFields missing
    const metaBadges = Cart.getProductBadgeData(product);
    const richTextBadge = metaBadges.find(m =>
        m.name.includes("storefront-badge") &&
        m.valueType === "RICH_TEXT"
    );
 
    // 3. Metafield HTML if available
    return richTextBadge?.value;
}
export default class Menu extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      canRenderContent: props.canRenderContent,
      editable: props.editable,
      showModal: false,
      website: window.CURRENT_WEBSITE,
      data: props.menu,
      cart: props.cart,
      showDeleteModal: false,
      deleteNavItem: null,
      deleteNavIndex: null,
      deleteData: null,
      promoIndex: 0,
      promoClosed: false,
      promoMessages: window.CURRENT_WEBSITE.extra?.menu_settings?.promo_messages || [],
      searchQuery: "",
      searchResults: [],
      searching: false,
      searchBarFocused: false,
      recommendedCartProducts: [],
      subscriptionData: {},
      openBundleIds: {}
    };

    this.rotateInterval = null

    this._updateMenu = General.debounce(
      () => {
        Backend.updateMenu(this.state.data);
      },
      1000,
      false
    );
    this._handleSearch = General.debounce(this._handleSearch.bind(this), 300);
    this._handleClosePromoBar = General.debounce(this._handleClosePromoBar.bind(this), 300);
  }

  loadRecommendedProducts() {
    const recommendationIds = (this.state.website?.extra?.cart_settings?.cart_recommendation_products || []).filter(Boolean).map(p => p.productId);

    if (!recommendationIds.length) return;

    Backend.getProducts(recommendationIds.join(",")).then(products => {
      const ordered = recommendationIds.map(id => products.find(p => p.campaignProductId === id)).filter(Boolean);

      this.setState({ recommendedCartProducts: ordered });

    }).catch(err => {
      this.setState({ recommendedCartProducts: [] });
    });
  }

  componentDidMount() {
    this.loadRecommendedProducts();
    this._setup()
    this._preloadSubscriptionDataFromCart(Cart.getLocalCart());
    Event.on('WEBSITE_UPDATED', () => {
      this.setState({
        website: window.CURRENT_WEBSITE
      })
      this._preloadSubscriptionDataFromCart(Cart.getLocalCart());
    });

    Event.on('MENU_UPDATED', (menu) => this.setState({
      data: menu,
    }));

    if (typeof window !== "undefined") {
      const promoClosed = sessionStorage.getItem("promoBarClosed") === "true";
      if (promoClosed) {
        this.setState({ promoClosed: true });
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState(nextProps);
  }

  componentWillUnmount(){
    Event.off('WEBSITE_UPDATED');
    if (this.rotateInterval) {
      clearInterval(this.rotateInterval);
      this.rotateInterval = null;
    }
  }

  updateWebsite(website) {
    let { data } = this.state;
    data.website = website;
    this.setState({ data });
  }

  updateCart(cart) {
    this.setState({ cart });
    this.setState({ cart }, () => this._preloadSubscriptionDataFromCart(cart));
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.cart !== this.state.cart) {
      this._preloadSubscriptionDataFromCart(this.state.cart);
    }
  }

  updateMenu(data, updateApi = true) {
    this.setState({ data }, () => {
      if (updateApi) {
        this._updateMenu();
      }
    });
  }

  _update(data, callback) {
    this.setState({ data }, () => {
      if (callback) {
        callback();
      }
      this._updateMenu();
    });
  }

  _updateExtraMenuSettings(field, value) {
    let { website } = this.state;

    if(!website.extra){
      website.extra = {menu_settings: {}}
    }

    if(!website.extra.menu_settings){
      website.extra.menu_settings = {}
    }

    website.extra.menu_settings[field] = value
    this.props.onUpdateWebsite(website)
  }

  _updateExtraProductPageSettings(field, value) {
    let { website } = this.state;

    if(!website.extra){
      website.extra = {product_page_settings: {}}
    }

    if(!website.extra.product_page_settings){
      website.extra.product_page_settings = {}
    }

    website.extra.product_page_settings[field] = value
    this.props.onUpdateWebsite(website)
  }

  _updateExtraCartSettings(field, value) {
    let { website } = this.state
    if(!website.extra){
      website.extra = { cart_settings: {} }
    }
    if(!website.extra.cart_settings){
      website.extra.cart_settings = {}
    }
    website.extra.cart_settings[field] = value
    this.props.onUpdateWebsite(website)
    this.setState({ website }, () => {
      if (field === "cart_recommendation_products" || field === "cart_recommendations_count") {
        this.loadRecommendedProducts();
      }
    });
  }

  showCartDropdown() {
    $(".co-bag .co-bag-dropdown").removeClass("hide");
    setTimeout(function () {
      $(".co-bag").addClass("show-bag-dropdown");
    }, 10);
  }

  hideCartDropdown() {
    $(".co-bag").removeClass("show-bag-dropdown");
    setTimeout(function () {
      $(".co-bag .co-bag-dropdown").addClass("hide");
    }, 600);
  }

  _setup() {
    let { data, website } = this.state;

    this.setState({
      data,
      loading: false,
    });
  }

  _addMenuItem(data) {
    data.nav_items.push({
      text: "New Menu Link Text",
      url: "#",
      nav_items: [],
      open_in_new_tab: false,
    });

    this._update(data);
  }

  _renderModalMenuItems(data) {
    return (
      <SmartList
        title="Menu Links"
        canDelete={false}
        items={data.nav_items}
        itemName="Menu Link"
        value={(navItem) => navItem.text}
        renderItem={(navItem, index) => {
          return (
            <Collapsible
              trigger={navItem.text}
              className="mb--1"
              overflowWhenOpen="visible"
              triggerSibling={() => {
                return (
                  <a
                    className="delete-item delete-item-collapsible"
                    style={{ right: 30 }}
                    onClick={() => {
                      this.setState({
                        showDeleteModal: true,
                        deleteNavItem: navItem,
                        deleteNavIndex:index,
                        deleteData: data
                      });
                    }}
                  />
                );
              }}
            >
              <div className="boxed boxed--sm overflow-visible">
                <span>Title</span>
                <input
                  type="text"
                  className="mb--05"
                  defaultValue={navItem.text}
                  onChange={(event) => {
                    let text = event.target.value;
                    navItem.text = text;
                    data.nav_items[index] = navItem;
                    this._update(data);
                  }}
                />

                <span>Link</span>
                <LinkSelect
                  type={"menu"}
                  url={navItem.url}
                  onUpdated={(url, ccPageId) => {
                    navItem.url = url;
                    navItem.cc_page_id = ccPageId;
                    data.nav_items[index] = navItem;
                    this._update(data);
                  }}
                />

                {!navItem.url?.startsWith("/#") && (
                  <>
                    <span>Open In New Tab</span>
                    <select
                      className="mb-3"
                      value={navItem.open_in_new_tab}
                      onChange={(event) => {
                        navItem.open_in_new_tab = event.target.value === "true";

                        data.nav_items[index] = navItem;

                        this._update(data);
                      }}
                    >
                      <option value="true">Yes</option>
                      <option value="false">No</option>
                    </select>
                  </>
                )}
                <Collapsible
                  trigger={`Show ${navItem.text} Dropdown Links`}
                  triggerWhenOpen={`Close ${navItem.text} Dropdown Links`}
                >
                  <Border className="mt--1">
                    {navItem.nav_items.map((childNavItem, childIndex) => {
                      return (
                        <Collapsible
                          key={childNavItem.id || childIndex.uid}
                          trigger={childNavItem.text}
                          className="mb--1"
                          overflowWhenOpen="visible"
                          triggerSibling={() => {
                            return (
                              <a
                                className="delete-item delete-item-collapsible"
                                style={{ right: 40 }}
                                onClick={() => {
                                  Backend.updateCCPageLinks(General.clone(childNavItem), "menu")
                                  navItem.nav_items.splice(childIndex, 1);
                                  data.nav_items[index] = navItem;
                                  this._update(data);
                                }}
                              />
                            );
                          }}
                        >
                          <br />
                          <span>Title</span>
                          <input
                            type="text"
                            defaultValue={childNavItem.text}
                            onChange={(event) => {
                              let text = event.target.value;
                              childNavItem.text = text;
                              navItem.nav_items[childIndex] = childNavItem;

                              data.nav_items[index] = navItem;
                              this._update(data);
                            }}
                          />
                          <br />
                          <br />
                          <span>Link</span>
                          <LinkSelect
                            type={"menu"}
                            url={childNavItem.url}
                            onUpdated={(url, ccPageId) => {
                              childNavItem.url = url;
                              childNavItem.cc_page_id = ccPageId;

                              navItem.nav_items[childIndex] = childNavItem;

                              data.nav_items[index] = navItem;

                              this._update(data);
                            }}
                          />

                          {!childNavItem.url?.startsWith("/#") && (
                            <>
                              <span>Open In New Tab</span>
                              <select
                                className="mb-3"
                                value={childNavItem.open_in_new_tab}
                                onChange={(event) => {
                                  childNavItem.open_in_new_tab =
                                    event.target.value === "true";

                                  navItem.nav_items[childIndex] = childNavItem;

                                  data.nav_items[index] = navItem;

                                  this._update(data);
                                }}
                              >
                                <option value="true">Yes</option>
                                <option value="false">No</option>
                              </select>
                            </>
                          )}
                        </Collapsible>
                      );
                    })}

                    <div className="row">
                      <div className="col-md-12">
                        <a
                          className="btn"
                          onClick={() => {
                            navItem.nav_items.push({
                              text: "New Dropdown Link",
                              url: "#",
                              uid: General.uuid(),
                              open_in_new_tab: false,
                            });
                            data.nav_items[index] = navItem;
                            this._update(data);
                          }}
                        >
                          <span className="btn__text">
                            Add {navItem.text} Dropdown Link
                          </span>
                        </a>
                      </div>
                    </div>
                  </Border>
                </Collapsible>
              </div>
            </Collapsible>
          );
        }}
        onUpdated={(navItems) => {
          data.nav_items = navItems;
          this._update(data);
        }}
      />
    );
  }

  cartDrawerButtons() {
    let { website } = this.state

    const productPageSettings = website.extra?.product_page_settings || {...DefaultData.PRODUCT_PAGE_SETTINGS}

    return (
      <>
        <DrawerCartSettings
          data={productPageSettings}
          onUpdated={settings => {
            if(!website.extra){
              website.extra = {product_page_settings: null}
            }
            website.extra.product_page_settings = settings
            this.props.onUpdateWebsite(website)
          }}
        />
      </>
    )
  }

  _renderCartThresholdDynamicSliderSettings(item, index, website) {
    const cartSettings = website?.extra?.cart_settings;
    if (item.componentType === "select") {
      return <div className="my-3" key={index}>
        <span>{item.label}</span>
        <Dropdown
          options={item.options}
          value={item.options.find((type) => type.value === (cartSettings?.[item.key] || item.defaultValue))}
          onChange={option => {
            this._updateExtraCartSettings(item.key, option.value);
          }}
          placeholder={item.label}
        />
      </div>
    }
    if (item.label === "Icon Color" && getIconType(cartSettings?.cart_threshold_slider_icon) === "svg") {
      return null;
    }
    return (
      <ColorPicker
        key={index}
        title={item.label}
        color={cartSettings?.[item.key] || item.defaultValue}
        onColorSelected={(color) => {
          this._updateExtraCartSettings(item.key, color)
        }}
      />
    )
  }

  _renderDrawerCartProductsSettings() {
    let { website } = this.state;
    return (
      <>
        <Border>
          <Collapsible
            trigger="Product Styling"
          >
            <br/>
            {
              CART_DRAWER_PRODUCTS_STYLE_CONSTANTS.map((item, index) => {
                return this._renderDynamicStyleSettings(item, index, website)
              })
            }
          </Collapsible>
        </Border>
      </>
    )
  }

  _renderCartThresholdSliderSettings() {
    let { website } = this.state
    const baseCurrencySymbol = window?.CURRENT_CAMPAIGN?.currencySymbol
    return (
      <>
        <Border>
          <Collapsible
            trigger="Cart Slider"
          >
            <br/>

            <Toggle
              id="toggle_cart_threshold_slider_enabled"
              checked={website?.extra?.cart_settings?.cart_threshold_slider_enabled}
              title="Enable"
              onChange={checked => {
                this._updateExtraCartSettings("cart_threshold_slider_enabled", checked)
              }}
            />

            {
              website?.extra?.cart_settings?.cart_threshold_slider_enabled && <>
                {
                  CART_DRAWER_SLIDER_CONSTANTS.map((item, index) => {
                    return this._renderCartThresholdDynamicSliderSettings(item, index, website);
                  })
                }

                <Border>
                  <Collapsible trigger="Slider Circle Image">
                    <IconAndSVGPicker
                      label="Current Icon"
                      displayIconFontSize={30}
                      displayIconClassName=""
                      currentIcon={website.extra?.cart_settings?.cart_threshold_slider_icon}
                      iconPickerColumnWidth={110}
                      iconPickerClassName=""
                      iconPickerWidth={356}
                      iconPickerRowHeight={110}
                      onSelected={(actionType, actionValue) => {
                        const icon = website.extra?.cart_settings?.cart_threshold_slider_icon
                        if (actionType === "svg") {
                          const newValue = updateIconValue(actionType, icon, actionValue)
                          this._updateExtraCartSettings("cart_threshold_slider_icon", newValue)
                        } else if (actionType === 'type') {
                          this._updateExtraCartSettings("cart_threshold_slider_icon", updateIconType(icon, actionValue))
                        } else {
                          let value = ""
                          if (actionValue.icon.startsWith("fa-")) {
                            value = actionValue.icon
                          } else {
                            value = `icon icon--lg icon-${actionValue.name}`
                          }
                          this._updateExtraCartSettings("cart_threshold_slider_icon", updateIconValue(actionType, icon, value))
                        }
                      }}
                      showDefaultIcon={true}
                      defaultIcon={<i className="stack-interface stack-menu" style={{fontSize: 30}}></i>}
                    />
                    </Collapsible>
                </Border>

                <span>
                  Price Threshold {baseCurrencySymbol ? `(${baseCurrencySymbol})` : ""}
                </span>
                <input
                  type="number"
                  className="mb--05"
                  defaultValue={website?.extra?.cart_settings?.cart_threshold_slider_price || ""}
                  placeholder="Price Threshold"
                  onChange={(event) => {
                    const value = event.target.value;
                    if (Number(value) && Number(value) > 0) {
                      this._updateExtraCartSettings("cart_threshold_slider_price", value)
                    }
                  }}
                />

                <span>
                  Pre-Threshold Message
                </span>
                <input
                  type="text"
                  className="mb--05"
                  defaultValue={website?.extra?.cart_settings?.cart_pre_threshold_slider_message || ""}
                  placeholder="Enter Message"
                  onChange={(event) => {
                    this._updateExtraCartSettings("cart_pre_threshold_slider_message", event.target.value)
                  }}
                />

                <span>
                  Post-Threshold Message
                </span>
                <input
                  type="text"
                  className="mb--05"
                  defaultValue={website?.extra?.cart_settings?.cart_post_threshold_slider_message || ""}
                  placeholder="Enter Message"
                  onChange={(event) => {
                    this._updateExtraCartSettings("cart_post_threshold_slider_message", event.target.value)
                  }}
                />
                <div className="tokensContainer">
                  <strong>Available Tokens:</strong>
                  <div>
                    <code>{'{{amount_left}}'}</code>: Shows remaining amount
                  </div>
                </div>
              </>
            }
          </Collapsible>
        </Border>
      </>
    )
  }

  _renderDynamicStyleSettings(item, index, website) {
    const cartSettings = website?.extra?.cart_settings;
    if (item.componentType === "select") {
      return <div className="my-3" key={index}>
        <span>{item.label}</span>
        <Dropdown
          options={item.options}
          value={item.options.find((type) => type.value === (cartSettings?.[item.key] || item.defaultValue))}
          onChange={option => {
            this._updateExtraCartSettings(item.key, option.value);
          }}
          placeholder={item.label}
        />
      </div>
    }
    return (
      <ColorPicker
        key={index}
        title={item.label}
        color={cartSettings?.[item.key] || item.defaultValue}
        onColorSelected={(color) => {
          this._updateExtraCartSettings(item.key, color)
        }}
      />
    )
  }

  _renderDrawerCartStyles() {
    const { website } = this.state;
    return (
      <>
        <Border>
          <Collapsible trigger="Drawer Styling">
          <br />
          {
            CART_DRAWER_STYLE_CONSTANTS.map((item, index) => {
              return this._renderDynamicStyleSettings(item, index, website)
            })
          }
          </Collapsible>
        </Border>
      </>
    )
  }

  _renderRecommendedProductStyles() {
    const { website } = this.state;
    return (
    <>
      <Border>
        <Collapsible trigger="Styling">
        <br />
        {
          CART_DRAWER_RECOMMENDATIONS_STYLE_CONSTANTS.map((item, index) => {
            return this._renderDynamicStyleSettings(item, index, website)
          })
        }
        </Collapsible>
      </Border>
    </>
    )
  }

  _renderModal() {
    let { data, website, showModal, promoMessages } = this.state;

    return (
      <PortalModal
        show={showModal}
        onHide={() => this.setState({ showModal: false })}
      >
        <h2>Menu</h2>

        <LogoEditor
          menu={data}
          onUpdated={(data) => {
            this.setState({ data });
            this._update(data);
          }}
        />

        <Border>
          <Collapsible trigger="Menu Links">
            <br/>
            {this._renderModalMenuItems(data)}
            {this._renderModalAddMenuItemButton(data)}
          </Collapsible>
        </Border>

        <Border>
          <Collapsible trigger="Header Extras">
            <br />
            <Collapsible trigger="Promo Bar">
              <br/>
              <Toggle
                id="promo_bar_toggle"
                checked={website.extra?.menu_settings?.show_promo_bar || false}
                title="Show Promo Bar"
                onChange={checked => {
                  this._updateExtraMenuSettings("show_promo_bar", checked)
                }}
              />
              {
                website.extra?.menu_settings?.show_promo_bar &&
                <>
                <span>
                  Position
                </span>
                  <Dropdown
                    options={PROMO_BAR_POSITION}
                    value={PROMO_BAR_POSITION.find((style) => style.value === website.extra?.menu_settings?.promo_bar_position) || "above"}
                    onChange={option => {
                      this._updateExtraMenuSettings("promo_bar_position", option.value)
                    }}
                    placeholder="Promo Bar Position"
                  />
                  <span>
                  Style
                </span>
                  <Dropdown
                    options={PROMO_BAR_STYLES}
                    value={PROMO_BAR_STYLES.find((style) => style.value === website.extra?.menu_settings?.promo_bar_style) || "single"}
                    onChange={option => {
                      this._updateExtraMenuSettings("promo_bar_style", option.value)
                    }}
                    placeholder="Promo Bar Style"
                  />
                  {
                    (!website.extra?.menu_settings?.promo_bar_style || website.extra?.menu_settings?.promo_bar_style === "single") ?
                      <>
                      <span>
                        Message
                      </span>
                        <input
                          type="text"
                          className="mb--05"
                          defaultValue={promoMessages?.[0]?.text || ""}
                          placeholder="Enter Promo Message"
                          onChange={(event) => {
                            let text = event.target.value;
                            promoMessages[0] = {text};
                            this.setState({ promoMessages });
                            this._updateExtraMenuSettings("promo_messages", promoMessages)
                          }}
                        />
                      </>
                      :
                      <>
                        {
                          website.extra?.menu_settings?.promo_bar_style === "rotate" &&
                          <>
                          <span>
                            Speed
                          </span>
                            <Dropdown
                              options={PROMO_BAR_ROTATE_INTERVAL}
                              value={PROMO_BAR_ROTATE_INTERVAL.find((speed) => speed.value === website.extra?.menu_settings?.promo_bar_rotate_interval) || 3000}
                              onChange={option => {
                                this._updateExtraMenuSettings("promo_bar_rotate_interval", option.value)
                              }}
                              placeholder="Promo Bar Rotate Interval"
                            />
                            <span>
                            Animation
                          </span>
                            <Dropdown
                              options={PROMO_BAR_ROTATE_ANIMATIONS}
                              value={PROMO_BAR_ROTATE_ANIMATIONS.find((animation) => animation.value === website.extra?.menu_settings?.promo_bar_rotate_animation) || "fade-in"}
                              onChange={option => {
                                this._updateExtraMenuSettings("promo_bar_rotate_animation", option.value)
                              }}
                              placeholder="Promo Bar Rotate Interval"
                            />
                          </>
                        }
                        {
                          website.extra?.menu_settings?.promo_bar_style === "continuous" &&
                          <>
                          <span>
                            Speed
                          </span>
                            <Dropdown
                              options={PROMO_BAR_CONTINUOUS_SPEED}
                              value={PROMO_BAR_CONTINUOUS_SPEED.find((speed) => speed.value === website.extra?.menu_settings?.promo_bar_continuous_speed) || 20}
                              onChange={option => {
                                this._updateExtraMenuSettings("promo_bar_continuous_speed", option.value)
                              }}
                              placeholder="Promo Bar Continuous Speed"
                            />
                          </>
                        }
                        <span>
                        Messages
                      </span>
                        {
                          promoMessages.map((promoMessage, index) => {
                            return (
                              <div key={"promo_"+index}>
                                <input
                                  type="text"
                                  className="mb--05"
                                  value={promoMessage.text || ""}
                                  onChange={(event) => {
                                    let text = event.target.value;
                                    promoMessages[index] = {text};
                                    this.setState({ promoMessages });
                                    this._updateExtraMenuSettings("promo_messages", promoMessages)
                                  }}
                                />
                                <a
                                  className="delete-item delete-item-collapsible mt-2"
                                  style={{ right: 19 }}
                                  onClick={() => {
                                    promoMessages.splice(index, 1);
                                    this.setState({ promoMessages });
                                    this._updateExtraMenuSettings("promo_messages", promoMessages)
                                  }}
                                />
                              </div>
                            )
                          })
                        }
                        {
                          (!website.extra?.menu_settings?.promo_messages || website.extra?.menu_settings?.promo_messages.length < 5) &&
                          <div className="row">
                            <div className="col-md-12">
                              <a
                                className="btn"
                                onClick={() => {
                                  if(!promoMessages){
                                    this.setState({ promoMessages: [{text: ""}] });
                                    this._updateExtraMenuSettings("promo_messages", [{text: ""}])
                                  }else{
                                    promoMessages.push({text: ""})
                                    this.setState({ promoMessages });
                                    this._updateExtraMenuSettings("promo_messages", promoMessages)
                                  }
                                }}
                              >
                                <span className="btn__text">Add Promo Message</span>
                              </a>
                            </div>
                          </div>
                        }
                      </>
                  }
                  <br/>
                  <Toggle
                    id="close_button_toggle"
                    checked={website.extra?.menu_settings?.close_button || false}
                    title="Close Button"
                    onChange={checked => {
                      this._updateExtraMenuSettings("close_button", checked)
                    }}
                  />
                  <br />
                  <ColorPicker
                    title={"Promo Bar Background Color"}
                    color={website.extra?.menu_settings?.promo_bar_background_color || website.primary_color}
                    onColorSelected={(color) => {
                      this._updateExtraMenuSettings("promo_bar_background_color", color)
                    }}
                  />

                  <ColorPicker
                    title={"Promo Bar Text Color"}
                    color={website.extra?.menu_settings?.promo_bar_text_color || 'rgb(255, 255, 255)'}
                    onColorSelected={(color) => {
                      this._updateExtraMenuSettings("promo_bar_text_color", color)
                    }}
                  />
                </>
              }
            </Collapsible>
            <Collapsible trigger="Search Bar">
              <br/>
              <Toggle
                id="search_bar_toggle"
                checked={website.extra?.menu_settings?.show_search_bar || false}
                title="Show Search Bar"
                onChange={checked => {
                  this._updateExtraMenuSettings("show_search_bar", checked)
                }}
              />
              {
                website.extra?.menu_settings?.show_search_bar &&
                <>
                  <span>Placeholder</span>
                  <input
                    type="text"
                    defaultValue={website.extra?.menu_settings?.search_bar_placeholder || 'Search Products...'}
                    onChange={event => {
                      let placeholder = event.target.value;
                      this._updateExtraMenuSettings("search_bar_placeholder", placeholder)
                    }}
                  />
                </>
              }
            </Collapsible>
            <Collapsible trigger="Buttons">
              <br />
              {this._renderPrimaryButtonToggle(data)}
              {this._renderSecondaryButtonToggle(data)}
            </Collapsible>
            {
              data.style === "hamburger" &&
              <Border>
                <Collapsible trigger="Hamburger Menu Style">
                  <br />
                  <Dropdown
                    options={HAMBURGER_MENU_STYLES}
                    value={website.extra?.menu_settings?.hamburger_menu_style || "overlay"}
                    onChange={option => {
                      this._updateExtraMenuSettings("hamburger_menu_style", option.value)
                      General.updateToggleClass()
                    }}
                    placeholder="Hamburger Menu Style"
                  />
                </Collapsible>
              </Border>
            }
          </Collapsible>
        </Border>

        <Border>
          <Collapsible trigger="Icons">
            <br />
            <h3 className="mb-2">Cart Icon</h3>
            <span>Cart icon route</span>
            <Dropdown
              options={CART_ICON_ROUTES}
              value={CART_ICON_ROUTES.find((mode) => mode.value === website.extra?.product_page_settings?.cart_icon_route) || "modal"}
              onChange={option => {
                website.extra.product_page_settings.cart_icon_route = option.value
                this._updateExtraProductPageSettings("cart_icon_route", option.value)
              }}
              placeholder="Select An Option"
            />
            <IconAndSVGPicker
              label="Current Icon"
              displayIconFontSize={30}
              displayIconClassName="cart-icon-picker-color"
              currentIcon={website?.extra?.menu_settings?.custom_cart_icon}
              iconPickerColumnWidth={110}
              iconPickerClassName=""
              iconPickerWidth={356}
              iconPickerRowHeight={110}
              onSelected={(actionType, actionValue) => {
                const icon = website?.extra?.menu_settings?.custom_cart_icon
                if (actionType === "svg") {
                  const newValue = updateIconValue(actionType, icon, actionValue)
                  this._updateExtraMenuSettings("custom_cart_icon", newValue)
                } else if (actionType === 'type') {
                  this._updateExtraMenuSettings("custom_cart_icon", updateIconType(icon, actionValue))
                } else {
                  let value = ""
                  if (actionValue.icon.startsWith("fa-")) {
                    value = actionValue.icon
                  } else {
                    value = `icon icon--lg icon-${actionValue.name}`
                  }
                  const newValue = updateIconValue(actionType, icon, value)
                  this._updateExtraMenuSettings("custom_cart_icon", newValue)
                }
              }}
              showDefaultIcon={true}
              defaultIcon={
                <svg
                  viewBox="0 0 30 30"
                  style={{ height: 30 }}
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M24.375 9.14062H20.3906V8.67188C20.3906 5.69531 17.9766 3.28125 15 3.28125C12.0234 3.28125 9.60938 5.69531 9.60938 8.67188V9.14062H5.625C5.10645 9.14062 4.6875 9.55957 4.6875 10.0781V25.7812C4.6875 26.2998 5.10645 26.7188 5.625 26.7188H24.375C24.8936 26.7188 25.3125 26.2998 25.3125 25.7812V10.0781C25.3125 9.55957 24.8936 9.14062 24.375 9.14062ZM18.2812 9.14062H11.7188V8.67188C11.7188 6.8584 13.1865 5.39062 15 5.39062C16.8135 5.39062 18.2812 6.8584 18.2812 8.67188V9.14062Z"
                    fill="#333333"
                  />
                </svg>
              }
            />

            <hr/>
            <h3 className="my-3">Hamburger Icon</h3>
            <IconAndSVGPicker
              label="Current Icon"
              displayIconFontSize={30}
              displayIconClassName=""
              currentIcon={website.extra?.menu_settings?.custom_hamburger_icon}
              iconPickerColumnWidth={110}
              iconPickerClassName=""
              iconPickerWidth={356}
              iconPickerRowHeight={110}
              onSelected={(actionType, actionValue) => {
                const icon = website.extra?.menu_settings?.custom_hamburger_icon
                if (actionType === "svg") {
                  const newValue = updateIconValue(actionType, icon, actionValue)
                  this._updateExtraMenuSettings("custom_hamburger_icon", newValue)
                } else if (actionType === 'type') {
                  this._updateExtraMenuSettings("custom_hamburger_icon", updateIconType(icon, actionValue))
                } else {
                  let value = ""
                  if (actionValue.icon.startsWith("fa-")) {
                    value = actionValue.icon
                  } else {
                    value = `icon icon--lg icon-${actionValue.name}`
                  }
                  this._updateExtraMenuSettings("custom_hamburger_icon", updateIconValue(actionType, icon, value))
                }
              }}
              showDefaultIcon={true}
              defaultIcon={<i className="stack-interface stack-menu" style={{fontSize: 30}}></i>}
            />
          </Collapsible>
        </Border>

        <Border>
          <Collapsible trigger="Drawer Cart Settings">
            <br />
            {this.cartDrawerButtons()}
            <Collapsible trigger="Cart Recommendation">
              <br/>
              <Toggle
                id="cart_recommendations_toggle"
                checked={this.state.website?.extra?.cart_settings?.cart_recommendations_enabled || false}
                title="Heading"
                onChange={(checked) => {
                  this._updateExtraCartSettings("cart_recommendations_enabled", checked);
                }}
              />

              {this.state.website?.extra?.cart_settings?.cart_recommendations_enabled &&
                <>
                  <span>Heading Text</span>
                  <input
                    type="text"
                    defaultValue={website.extra?.cart_settings?.cart_recommendations_heading || ""}
                    onChange={event => {
                      let recommendationHeading = event.target.value;
                      this._updateExtraCartSettings("cart_recommendations_heading", recommendationHeading)
                    }}
                  />
                </>
              }
              <Border>
                <Collapsible trigger={`Number of recommendations to be displayed`}>
                  <br />
                  <span>Choose the number of products</span>
                  <div className="input-select">
                    <select
                      value={this.state.website?.extra?.cart_settings?.cart_recommendations_count || DEFAULT_RECOMMENDATION_COUNT}
                      onChange={(e) => {
                        const selectedCount = e.target.value;
                        this._updateExtraCartSettings("cart_recommendations_count", selectedCount);

                        let current = [...(this.state.website.extra.cart_settings.cart_recommendation_products || [])];
                        current.length = selectedCount;
                        this._updateExtraCartSettings("cart_recommendation_products", current);
                      }}
                    >
                      {[1, 2, 3, 4, 5, 6].map((num) => (
                        <option key={num} value={num}>
                          {num}
                        </option>
                      ))}
                    </select>
                  </div>
                </Collapsible>
              </Border>
              {this._renderRecommendedProductSelectors()}
              {this._renderRecommendedProductStyles()}
            </Collapsible>
            <Collapsible trigger="Subscribe & Save">
              <br/>
              <Toggle
                id="subscribe"
                checked={website.extra?.menu_settings?.show_sub_and_save || false}
                title="Show Subscribe & Save"
                tooltip="Show Subscribe and Save options for one-time products in the cart."
                onChange={checked => {
                  this._updateExtraMenuSettings("show_sub_and_save", checked)
                }}
              />
              {
                website.extra?.menu_settings?.show_sub_and_save && <>
                  {
                    CART_DRAWER_SUB_AND_SAVE_CONSTANTS.map((item, index) => {
                      const key = `sub_and_save_${item.key}`;
                      return <ColorPicker
                        key={index}
                        title={item.label}
                        color={website.extra?.menu_settings?.[key] || item.defaultValue}
                        onColorSelected={(color) => {      
                          this._updateExtraMenuSettings(key, color)
                        }}
                      />
                    })
                  }
                </>
              }
            </Collapsible>
            {this._renderCartThresholdSliderSettings()}
            {this._renderDrawerCartProductsSettings()}
            {this._renderDrawerCartStyles()}
          </Collapsible>
        </Border>

        <Border>
          <Collapsible trigger="Colors">
            <br />
            <ColorPicker
              title={"Menu Background Color"}
              color={data.settings.quaternary_color}
              onColorSelected={(color) => {
                data.settings.quaternary_color = color;
                this._update(data);
              }}
            />

            <br />

            <ColorPicker
              title={"Menu Text Color"}
              color={data.settings.secondary_color}
              onColorSelected={(color) => {
                data.settings.secondary_color = color;
                this._update(data);
              }}
            />

            <br />

            <ColorPicker
              title={
                "Scrolling Menu Background Color (menu changes when you scroll)"
              }
              color={data.settings.tertiary_color}
              onColorSelected={(color) => {
                data.settings.tertiary_color = color;
                this._update(data);
              }}
            />

            <br />

            <ColorPicker
              title={"Scrolling Menu Text Color (menu changes when you scroll)"}
              color={data.settings.primary_color}
              onColorSelected={(color) => {
                data.settings.primary_color = color;
                this._update(data);
              }}
            />

            <br />

            <ColorPicker
              title={"Cart Icon Color"}
              color={website.extra?.menu_settings?.cartIcon_color || website.primary_color}
              onColorSelected={(color) => {
                if(!website.extra){
                  website.extra = {menu_settings: {}}
                }
                if (!website.extra.menu_settings) {
                  website.extra.menu_settings = {};
                }
                website.extra.menu_settings.cartIcon_color = color;
                this._updateExtraMenuSettings("cartIcon_color", color);
              }}
            />
          </Collapsible>
        </Border>
      </PortalModal>
    );
  }

  _getProductOption(product){
    if(!product){
      return null
    }

    return {
      label: product.productName,
      value: product.productId,
      data: product
    }
  }

  _renderRecommendedProductSelectors() {
    const count = this.state.website?.extra?.cart_settings?.cart_recommendations_count || DEFAULT_RECOMMENDATION_COUNT;
    const products = this.state.website?.extra?.cart_settings?.cart_recommendation_products || [];

    return (
      <Border>
        <Collapsible trigger="Select Recommendation Products">
          <br/>
          {Array.from({ length: count }).map((_, index) => (
            <div key={index}>
              <label>{`Select Product #${index + 1}`}</label>
              <AsyncSelect
                endpoint={window.CCApi.Products}
                classNamePrefix="async-select-paginate"
                placeholder="Please Select A Product"
                noOptionsMessage={() => "No Products Found"}
                value={this._getProductOption(products[index])}
                onSelected={(product) => {
                  const current = [...products];
                  current[index] = {
                    productId: product.productId,
                    productName: product.productName
                  };
                  this._updateExtraCartSettings("cart_recommendation_products", current);
                }}
                getOptions={(options) => options.map(option => ({
                  label: option[1].productName,
                  value: option[1].productId,
                  data: option[1]
                }))}
              />
            </div>
          ))}
        </Collapsible>
      </Border>
    );
  }

  _renderModalAddMenuItemButton(data) {
    return (
      <div className="row">
        <div className="col-md-12">
          <a className="btn" onClick={() => this._addMenuItem(data)}>
            <span className="btn__text">Add Menu Link</span>
          </a>
        </div>
      </div>
    );
  }

  _renderPrimaryLogo(data, editable) {
    if (data.logo_custom == true) {
      return this._renderLogoCustom(data.primary_logo, "dark");
    }
    return this._renderLogo(data.primary_image, "dark", editable, (image) => {
      data.primary_image = image;
      this._update(data);
    });
  }

  _renderSecondaryLogo(data, editable) {
    if (data.logo_custom == true) {
      return this._renderLogoCustom(data.secondary_logo, "light");
    }
    return this._renderLogo(
      data.secondary_image,
      "light",
      editable,
      (image) => {
        data.secondary_image = image;
        this._update(data);
      }
    );
  }

  _renderLogo(image, theme, editable, onUpdated) {
    if (!image) {
      return null;
    }

    let className = "logo logo-" + theme;

    return (
      <Img
        className={className + " size-" + this.state.data.logo_size}
        img={image}
        size={Sizes.SMALL}
        alt={"logo"}
        editable={false}
        renderModal={(content) => this.props.renderModal(content)}
        onUpdated={(image) => {
          onUpdated(image);
        }}
      />
    );
  }

  _renderLogoCustom(logo, theme) {
    return (
      <div className={`logo logo-${theme}`}>
        {this._renderLogoCustomContent(logo, theme)}
      </div>
    );
  }

  _renderLogoCustomContent(logo, theme) {
    if (logo.style == "icon_top_text_bottom") {
      return this._renderLogoCustomIconTopTextBottom(logo);
    } else if (logo.style == "text_top_icon_bottom") {
      return this._renderLogoCustomTextTopIconBottom(logo);
    } else if (logo.style == "text_left_icon_right") {
      return this._renderLogoCustomTextLeftIconRight(logo);
    }

    return this._renderLogoCustomIconLeftTextRight(logo);
  }

  _renderLogoCustomIconTopTextBottom(logo) {
    return (
      <div className="d-flex flex-column p-icon-top">
        {this._renderLogoCustomIcon(logo)}
        {this._renderLogoCustomText(logo)}
      </div>
    );
  }

  _renderLogoCustomTextTopIconBottom(logo) {
    return (
      <div className="d-flex flex-column p-icon-btm">
        {this._renderLogoCustomText(logo)}
        {this._renderLogoCustomIcon(logo)}
      </div>
    );
  }

  _renderLogoCustomTextLeftIconRight(logo) {
    return (
      <div className="d-flex align-items-center p-icon-right">
        {this._renderLogoCustomText(logo)}
        {this._renderLogoCustomIcon(logo)}
      </div>
    );
  }

  _renderLogoCustomIconLeftTextRight(logo) {
    return (
      <div className="d-flex align-items-center p-icon-left">
        {this._renderLogoCustomIcon(logo)}
        {this._renderLogoCustomText(logo)}
      </div>
    );
  }

  _renderLogoCustomText(logo, className = "") {
    let { data } = this.state;
    return (
      <span
        className={className + " logo-text"}
        style={{
          fontFamily: logo.font.family_name,
          fontSize: parseInt(data.logo_size),
          fontWeight: parseInt(logo.font.weight),
          color: logo.text_color || window.CURRENT_PAGE_PRIMARY_COLOR,
        }}
      >
        {logo.text}
      </span>
    );
  }

  _renderLogoCustomIcon(logo, className = "") {
    let { data } = this.state;
    return (
      <>
        {
          getIconType(logo.icon) === 'svg' ?
            <img className="m-0" height={parseInt(data.logo_size) + parseInt(data.logo_size * 0.2)} src={getSVGIcon(logo.icon)} />
          :
            <i
              className={`logo-icon icon icon--sm ${getStandardIcon(logo.icon)}`}
              style={{
                color: logo.icon_color || window.CURRENT_PAGE_PRIMARY_COLOR,
                fontSize: parseInt(data.logo_size) + parseInt(data.logo_size * 0.2),
              }}
            />
        }
      </>
    );
  }

  _renderPrimaryButtonToggle(data) {
    return (
      <>
        <div class="row">
          <div class="col-md-8">
            <h4>Primary</h4>
          </div>
          <div class="col-md-4 text-right">
            <div class="input-checkbox input-checkbox--switch">
              <input
                id="menu__cb_pb"
                type="checkbox"
                defaultChecked={data.primary_button}
                onChange={(e) => {
                  if (e.target.checked) {
                    data.primary_button = DEFAULT_PRIMARY_BUTTON;
                  } else {
                    Backend.updateCCPageLinks(General.clone(data.primary_button), "menu")
                    data.primary_button = null;
                  }
                  this._update(data);
                }}
              />
              <label for="menu__cb_pb"></label>
            </div>
          </div>
        </div>
      </>
    );
  }

  _renderSecondaryButtonToggle(data) {
    return (
      <>
        <div class="row">
          <div class="col-md-8">
            <h4>Secondary</h4>
          </div>
          <div class="col-md-4 text-right">
            <div class="input-checkbox input-checkbox--switch">
              <input
                id="menu__cb_sb"
                type="checkbox"
                defaultChecked={data.secondary_button}
                onChange={(e) => {
                  if (e.target.checked) {
                    data.secondary_button = DEFAULT_SECONDARY_BUTTON;
                  } else {
                    Backend.updateCCPageLinks(General.clone(data.secondary_button), "menu")
                    data.secondary_button = null;
                  }
                  this._update(data);
                }}
              />
              <label for="menu__cb_sb"></label>
            </div>
          </div>
        </div>
      </>
    );
  }

  _renderNavItems(navItems, hamburgerHeader) {
    if (!navItems) {
      return null;
    }

    return navItems.map((navItem) => {
      let url = Navigation.getUrl(navItem.url, navItem.cc_page_id)
      if (navItem.nav_items.length === 0) {
        return (
          <li>
            <a
              href={url}
              target={navItem.open_in_new_tab ? "_blank" : ""}
              onClick={() => {
                if (!navItem.open_in_new_tab) {
                  General.setLocationHref(url)
                }
              }}
            >
              {navItem.text}
            </a>
          </li>
        );
      }
      return (
        <li
          className={`${
            hamburgerHeader
              ? "menu-item dropdown"
              : "menu-item dropdown dropdown--hover"
          }`}
        >
          <a
            href={url}
            target={navItem.open_in_new_tab ? "_blank" : ""}
            onClick={() => {
              if (!navItem.open_in_new_tab) {
                General.setLocationHref(url)
              }
            }}
            class="dropdown__trigger"
          >
            <span>{navItem.text}</span>
          </a>
          <div class="dropdown__container text-left">
            <div class="container">
              <div class="row">
                <div
                  className={`${
                    hamburgerHeader
                      ? "dropdown__content col-auto"
                      : "dropdown__content col-md-2 col-11"
                  }`}
                >
                  <ul class="menu-vertical">
                    {navItem.nav_items.map((childNavItem) => {
                      const childNavItemUrl = Navigation.getUrl(childNavItem.url, childNavItem.cc_page_id)
                      return (
                        <li class="menu-item text-truncate">
                          <a
                            href={childNavItemUrl}
                            target={
                              childNavItem.open_in_new_tab ? "_blank" : ""
                            }
                            onClick={() => {
                              if (!childNavItem.open_in_new_tab) {
                                General.setLocationHref(childNavItemUrl)
                              }
                            }}
                            className={
                              childNavItem.url.includes("#")
                                ? "dropdown-inactive"
                                : ""
                            }
                          >
                            <span>{childNavItem.text}</span>
                          </a>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </li>
      );
    });
  }

  _renderEditable(editable) {
    if (!editable) {
      return null;
    }

    return (
      <>
        <div className="nav-button-edit">
          <div className="button-slide">
            <a
              className="button"
              href="javascript:void(0)"
              onClick={() => {
                this.setState({ showModal: true });
              }}
            >
              <span class="slide-text">Edit Menu</span>
              <i class="material-icons m-icon-s1 c-white-opa-8">settings</i>
            </a>
          </div>
        </div>
        {this._renderModal()}
      </>
    );
  }

  _renderMenuContent(data, editable) {
    if (data.logo_position === "center") {
      return this._renderMenuContentStyleCenter(data, editable);
    }
    return this._renderMenuContentStyleDefault(data, editable);
  }

  _renderMenuContentStyleDefault(data, editable) {
    const { searchBarFocused, searchTerm } = this.state;
    const isSearchExpanded = searchBarFocused || !!searchTerm;
    const searchColumnClass = isSearchExpanded ? "col-md-2" : "col-md-1";
    const buttonColumnClass = isSearchExpanded ? "col-md-3" : "col-md-4";
    return (
      <>
        <div className="col-md-2 text-center text-left-sm hidden-xs ">
          {this._renderMenuLogo(data, editable)}
        </div>
        <div className={`${searchColumnClass} search-column bar-module-margin-zero searchBar-default`}>
          {this._renderSearchBar()}
        </div>
        <div className="col-md-5 bar-module-margin-zero left-logo">
          {this._renderMenuNavItems(data, editable)}
        </div>
        <div className={`${buttonColumnClass} buttons-column text-right text-left-md menu-buttons`}>
          {this._renderMenuButtons(data, editable)}
        </div>
        {this._renderEditable(editable)}
      </>
    );
  }

  _renderMenuContentStyleCenter(data, editable) {
    const { searchBarFocused, searchTerm } = this.state;
    const isSearchExpanded = searchBarFocused || !!searchTerm;
    const buttonColumnClass = isSearchExpanded ? "col-md-3" : "col-md-4";
    const searchColumnClass = isSearchExpanded ? "col-md-2" : "col-md-1";

    return (
      <>
        <div className="col-md-2 text-center text-left-sm hidden-xs order-md-2">
          {this._renderMenuLogo(data, editable)}
        </div>
        <div className="col-md-5 order-md-1 bar-module-margin-zero">
          {this._renderMenuNavItems(data, editable)}
        </div>
        <div className={`${searchColumnClass} search-column order-md-3 bar-module-margin-zero searchBar`}>
          {this._renderSearchBar()}
        </div>
        <div className={`${buttonColumnClass} buttons-column text-right text-left-md order-md-4 menu-buttons`}>
          {this._renderMenuButtons(data, editable)}
        </div>
        {this._renderEditable(editable)}
      </>
    );
  }

  _renderMenuNavItems(data, editable, hamburgerHeader) {
    return (
      <div className={`${hamburgerHeader ? "" : "bar__module navItems"}`}>
        <ul className="menu-horizontal">
          {this._renderNavItems(data.nav_items, hamburgerHeader)}
        </ul>
      </div>
    );
  }

  _registerCheckoutButtonListener() {
    let { website } = this.state;

    let cartIconAction = website.extra?.product_page_settings?.cart_icon_route || "modal"

    if (this.registeredCheckoutButtonListener || cartIconAction !== "modal") {
      return;
    }

    setTimeout(() => {
      $(".nav-checkout").click(() => {
        this.showCartDropdown();
      });

      $(
        ".co-bag .head .close, .co-bag .co-bag-dropdown-bg"
      ).on("click", () => {
        this.hideCartDropdown();
      });

      this.registeredCheckoutButtonListener = true;
    }, 3000);
  }

  renderRecommendedProducts(cart) {
    const { website, recommendedCartProducts } = this.state;
    const cartSettings = website?.extra?.cart_settings || {};

    const heading = cartSettings.cart_recommendations_heading || "";
    const isHeadingEnabled = cartSettings.cart_recommendations_enabled;

    if (recommendedCartProducts.length === 0) {
      return null;
    }

    const cartItems = cart?.items || [];

    const cartProductIdsObject = cartItems.reduce((obj, item) => {
      const productId = item?.product?.productId;
      if (productId) {
        obj[productId] = true;
      }
      return obj;
    }, {});

    const filteredRecommendations = recommendedCartProducts.filter(
      product => !cartProductIdsObject[product.productId]
    );

    if (!filteredRecommendations.length) {
      return null;
    }

    return (
      <div className="mt-3">
        {isHeadingEnabled && <h3
          className="mb-3 text-center"
          style={{ color: cartSettings?.cart_recommendation_heading_text_color || "#252525" }}
        >{heading}</h3>}

        {filteredRecommendations.map((product, index) => {
          const {
            productId,
            imageUrl,
            productName,
            campaignProductId,
            compareAtPrice,
            price,
            hasVariants,
            variants,
            customMessageOptions
          } = product;

          const hasVariantOptions = hasVariants || (Array.isArray(variants) && variants.length > 0);
          const hasCustomMessage = Array.isArray(customMessageOptions?.split(',')) &&
                                  customMessageOptions.split(',').some(opt => opt.trim().length > 0);
          const showAddToCart = !hasVariantOptions && !hasCustomMessage;

          return (
          <>
            <style dangerouslySetInnerHTML={{
                  __html: `
                  .side-cart-recommendation-container${index} {
                    background-color: ${cartSettings?.cart_recommendation_background_color || "#ffffff00"} !important;
                    border-color: ${cartSettings?.cart_recommendation_border_color || "#dee2e6"} !important;
                    border-radius: ${cartSettings?.cart_recommendation_border_type === "rounded" ? "12px" : "0px"} !important;
                  }
                  `
            }}></style>
            <div
              key={productId}
              className={`row mb-3 items ml-0 mr-0 mt-0 border align-items-center side-cart-recommendation-container${index}`}
              style={{
                backgroundColor: cartSettings?.cart_recommendation_background_color || "#ffffff00",
                borderColor: cartSettings?.cart_recommendation_border_color || "#dee2e6",
                borderRadius: cartSettings?.cart_recommendation_border_type === "rounded" ? "12px" : "0px"
              }}
            >
              <div className="col-sm-4 m-0 text-center">
                <img
                  src={imageUrl}
                  alt={productName}
                  className="img"
                  width="100"
                  height="100"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    General.setLocationHref(Navigation.getProductUrl(campaignProductId));
                  }}
                />
              </div>
              <div className="col side-cart-recommendation-column">
                <div className="m-0 mb-1">
                  <h5 style={{ color: cartSettings?.cart_recommendation_product_title_text_color || "#252525" }} >{productName}</h5>
                </div>
                <div className="d-flex align-items-center price">
                  {compareAtPrice > 0 && <span class="h5 type--strikethrough m-0 pr-1" style={{ color: cartSettings?.cart_recommendation_compare_at_price_color || "#666666" }}>{ Currency.toFormat(compareAtPrice) }</span>}
                  <span class="h5 m-0" style={{ color: cartSettings?.cart_recommendation_price_color || "#252525" }}>{ Currency.toFormat(price) }</span>
                </div>
                <style dangerouslySetInnerHTML={{
                  __html: `
                  .s-header .h-bar.pos-fixed .d-header .side-cart-recommendation-column .btn--side-cart-recommendation${index} {
                    background-color: ${cartSettings?.cart_recommendation_button_color || website?.primary_color} !important;
                    border-color: ${cartSettings?.cart_recommendation_button_border_color || website?.primary_color} !important;
                    color: ${cartSettings?.cart_recommendation_button_title_color || "#fff"} !important;
                  }
                  `
                }}></style>
                <button
                  className={`btn btn--primary mb-2 w-100 btn--side-cart-recommendation${index}`}
                  onClick={() => {
                    if (showAddToCart) {
                      this.props.onAddToCartPressed(product, null, [], 1, null);
                    } else {
                      General.setLocationHref(Navigation.getProductUrl(campaignProductId));
                    }
                  }}
                  style={{
                    backgroundColor: cartSettings?.cart_recommendation_button_color || website?.primary_color,
                    borderColor: cartSettings?.cart_recommendation_button_border_color || website?.primary_color,
                    color: cartSettings?.cart_recommendation_button_title_color || "#fff"
                  }}
                >
                  {showAddToCart ? "Add To Cart" : "More Details"}
                </button>
              </div>
            </div>
          </>
          );
        })}
      </div>
    );
  }

  toggleBundleDisplay = (id) => {
    this.setState(prevState => {
      const isOpen = prevState.openBundleIds[id];
      return {
        openBundleIds: {
          ...prevState.openBundleIds,
          [id]: !isOpen
        }
      };
    });
  };

  _renderCartItems(cart){
    let { website, openBundleIds } = this.state
    if(!cart) return null;
    const cartSettings = website?.extra?.cart_settings;
    const productTextColor = { color: cartSettings?.cart_drawer_product_text_color || "#000000" };
    return cart.items.map((item, index) => {
      let variantDetailId = item.ccCartKey.split('.')[1]
      let product = item.product
      let quantity = item.quantity
      let frequency = item.frequency

      if(!product) return

      let price = product.cycle1_price

      let variant = product.variants?.find(productVariant => {
        return productVariant.variantDetailId === parseInt(variantDetailId)
      })

      if(variant && variant.price) {
        price = variant.price
      }

      const sig = ssTags.key(product, variantDetailId, frequency)
      const ssTag = ssTags.get(sig)
      const productUrl = Navigation.getProductUrl(product.campaignProductId)
      const bundleStringArray = JSON.parse(sessionStorage.getItem("bundleStringArray") || "{}");
      const variantList = bundleStringArray[product?.campaignProductId]?.split("|")?.splice("2") || [];
      return (
        <React.Fragment key={ssTags.key(product, variantDetailId, frequency)}>
          <div style={{
            border: `1px solid ${cartSettings?.cart_drawer_product_border_color || "#e0e0e0"}`,
            borderRadius: cartSettings?.cart_drawer_product_border_type === "square" ? "0" : "6px 6px 6px 6px",
            marginTop: "5px",
            backgroundColor: cartSettings?.cart_drawer_product_background_color || "#ffffff"
          }}>
            <div className="row m-0 item">
              <div
                className="img m-0"
                style={{
                  backgroundImage:
                    `url('${product.imageUrl}')`,
              }}
              />
              <div className="col">
                <div
                  className="price"
                  style={{ color: cartSettings?.cart_drawer_product_price_color || "#000000" }}
                >{Currency.toFormat(price)}</div>
                <a
                  className="cart-dtb"
                  href={productUrl}
                  onClick={() => {
                    General.setLocationHref(productUrl)
                  }}
                >
                  <div
                    className="title"
                    style={productTextColor}
                  >{product.productName}</div>
                </a>
                {(() => { 
                  const badge = getHsaBadge(product); 
                  return badge  ? <span dangerouslySetInnerHTML={{ __html: badge }} /> : null;
                })()}
                {
                  variant &&
                  <div
                    className="variant"
                    style={{ color: cartSettings?.cart_drawer_product_subtext_color || "#000000" }}
                    >Variant: {variant.title}</div>
                }
                <div style={{ display: "flex", alignItems: "center"}}>
                  <div
                    className="quantity"
                    style={productTextColor}
                  >Quantity: {quantity}</div>
                  {product.isVariantBundle ? <div>
                    <span
                      style={{cursor: "pointer", userSelect: "none", marginLeft: "10px", ...productTextColor}}
                      onClick={() => this.toggleBundleDisplay(product.campaignProductId)}
                      aria-label={openBundleIds[product.campaignProductId] ? "Hide bundle details" : "Show bundle details"}
                    >
                      {openBundleIds[product.campaignProductId] ? <FaChevronUp/> : <FaChevronDown/>}
                    </span>
                  </div>: null}
                </div>
                {product.isVariantBundle && openBundleIds[product.campaignProductId] ? (
                  <ul style={{marginTop: 8}}>
                    {variantList.map((variant, idx) => (
                      <li key={idx} style={{ lineHeight: "1.5em", ...productTextColor }}>
                        {variant && variant}
                      </li>
                    ))}
                  </ul>
                ) : null}
                {
                  item.customMessage?.map(customMessage => {
                    let [key, value] = customMessage.split(':')
                    return (
                      <div
                        className="quantity"
                        style={productTextColor}
                      >{key}: {value}</div>
                    )
                  })
                }
                {
                  item.frequency &&
                  <div
                    className="quantity"
                    style={productTextColor}
                  >Frequency: {item.frequency}</div>
                }
              </div>
              <div className="col-auto p-0 delete">
                <a
                  href="javascript:void(0);"
                  className={`material-icons ${product.campaignProductId == window?.CURRENT_CAMPAIGN?.insureShipProductId ? " d-none" : ""}`}
                  style={{ color: cartSettings?.cart_drawer_product_remove_button_color || "#fa6160", width: "25px" }}
                  onClick={() => {
                    Cart.remove(product, variant, item.customMessage, 1, frequency)
                      .then((cart) => {
                        this.setState({ cart });
                        this.props.onUpdatedCart(cart);
                        const bundleItems = JSON.parse(sessionStorage.getItem("bundleItems") || "{}");
                        if (product?.campaignProductId && bundleItems[product.campaignProductId]) {
                          delete bundleItems[product.campaignProductId];
                          sessionStorage.setItem("bundleItems", JSON.stringify(bundleItems));
                        }
                        const bundleStringArray = JSON.parse(sessionStorage.getItem("bundleStringArray") || "{}");
                        if (product?.campaignProductId && bundleStringArray[product.campaignProductId]) {
                          delete bundleStringArray[product.campaignProductId];
                          sessionStorage.setItem("bundleStringArray", JSON.stringify(bundleStringArray));
                        }
                      })
                      .catch((error) => {
                        Notify.error(error.message);
                      });
                  }}
                >
                  delete
                </a>
              </div>
        </div>
            {(website.extra?.menu_settings?.show_sub_and_save && (product.recurringProductId || (item.frequency && ssTag))) &&
              this._renderSubscription(product, {
                variant,
                quantity,
                customMessage: item.customMessage,
                frequency,
                itemSig: sig,
                ssTag
              })
            }
          </div>
        </React.Fragment>
      )
    })
  }

  _replaceWordsWithJSX(text = "", regex, renderMatch) {
    const parts = [];
    let lastIndex = 0;
    let match;
    let key = 0;
    while ((match = regex.exec(text)) !== null) {
      const { index } = match;
      // Push the text before the match
      if (index > lastIndex) {
        parts.push(<React.Fragment key={key++}>{text.slice(lastIndex, index)}</React.Fragment>);
      }
      // Push the JSX-rendered match
      parts.push(<React.Fragment key={key++}>{renderMatch(match[0], match)}</React.Fragment>);
      lastIndex = index + match[0].length;
    }
    // Push any remaining text after the last match
    if (lastIndex < text.length) {
      parts.push(<React.Fragment key={key++}>{text.slice(lastIndex)}</React.Fragment>);
    }
    return <>{parts}</>;
  }

  _renderCartThresholdSliderContent(subTotal) {
    let { website } = this.state
    const cartSettings = website?.extra?.cart_settings;
    if (!cartSettings?.cart_threshold_slider_enabled) {
      return null
    }
    const thresholdSliderPrice = Number(cartSettings?.cart_threshold_slider_price) || 0
    const cartSubTotal = Number(subTotal) || 0
    const remainingAmountToReachThreshold = thresholdSliderPrice - cartSubTotal
    const remainingDisplayAmountToReachThreshold = <>{Currency.toFormat(remainingAmountToReachThreshold)}</>
    const preThresholdSliderMessageValue = cartSettings?.cart_pre_threshold_slider_message
    const postThresholdSliderMessageValue = cartSettings?.cart_post_threshold_slider_message
    const preThresholdSliderMessage = this._replaceWordsWithJSX(preThresholdSliderMessageValue, /[{][{]\s*amount\s*_\s*left\s*[}][}]/ig, (match) => (
      <>{remainingDisplayAmountToReachThreshold}</>
    ));
    let thresholdSliderPercentage = Math.ceil((cartSubTotal / (thresholdSliderPrice || 1)) * 75)
    thresholdSliderPercentage = thresholdSliderPercentage >= 75 ? 100 : thresholdSliderPercentage
    const sliderColor = cartSettings?.cart_threshold_slider_color || website.primary_color
    return (
      <div>
        {
          thresholdSliderPercentage === 100 && <CanvasConfettiBox />
        }
        <div
          className="head m-0 p-3 px-3 align-items-center justify-content-between h-auto"
          style={{ borderColor: cartSettings?.cart_drawer_line_color || website?.primary_color }}
        >
          <div
            className="p-2"
            style={{
              backgroundColor: cartSettings?.cart_threshold_slider_background_color || "#fff",
              border: `1px solid ${cartSettings?.cart_threshold_slider_border_color || "#fff"}`,
              borderRadius: cartSettings?.cart_threshold_slider_border_type === "rounded" ? "12px" : "0px"
            }}
          >
            <div
              className="text-center mb-4 cart-threshold-slider-message"
              style={{ color: cartSettings?.cart_threshold_slider_text_color || "#000" }}
            >
              {thresholdSliderPercentage === 100 ?
                <div>{postThresholdSliderMessageValue}</div>
                :
                preThresholdSliderMessage
              }
            </div>
            <div className="storefront-position-relative cart-threshold-slider-box-parent">
              <div className="cart-threshold-slider-box">
                <div className="cart-threshold-slider-progress" style={{
                  backgroundColor: sliderColor,
                  width: `${thresholdSliderPercentage}%`
                }}>
                </div>
              </div>
              <div className="cart-threshold-slider-icon-container-parent">
                <div className="cart-threshold-slider-icon-container" style={{
                  border: `3px solid ${sliderColor}`,
                  color: sliderColor,
                  backgroundColor: cartSettings?.cart_threshold_slider_icon_background_color || "#fff"
                }}>
                  {
                    getIconType(cartSettings?.cart_threshold_slider_icon) === 'svg' ?
                        <img className="m-0" height={30} width="auto" src={getSVGIcon(cartSettings?.cart_threshold_slider_icon)} />
                      :
                      <i  style={{ fontSize: "30px" }} className={getStandardIcon(cartSettings?.cart_threshold_slider_icon)}></i>
                  }
                </div>
                <div className="cart-threshold-slider-icon-price" style={{
                    color: sliderColor
                  }}
                >
                  {Currency.toFormat(thresholdSliderPrice)}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  _ensureSubscriptionData = async (recurringProductId) => {
    if (!recurringProductId) return;
    const entry = this.state.subscriptionData?.[recurringProductId];
    if (entry?.loading || entry?.product || entry?.error) return;
    this.setState(prev => ({
      subscriptionData: {
        ...prev.subscriptionData,
        [recurringProductId]: { loading: true }
      }
    }));
    try {
      const products = await Backend.getProducts(recurringProductId);
      const subscribeAndSaveProduct = products?.[0] ?? null;
      const options = subscribeAndSaveProduct ? Cart.getOptions(subscribeAndSaveProduct) : null;
      this.setState(prev => ({
        subscriptionData: {
          ...prev.subscriptionData,
          [recurringProductId]: { loading: false, product: subscribeAndSaveProduct, options }
        }
      }));
    } catch (e) {
      console.error("Subscription fetch failed:", e);
      this.setState(prev => ({
        subscriptionData: {
          ...prev.subscriptionData,
          [recurringProductId]: { loading: false, error: true }
        }
      }));
    }
  };

  _preloadSubscriptionDataFromCart = (cart) => {
    const items = cart?.items || [];
    const ids = [...new Set(items
      .map(i => i?.product?.recurringProductId)
      .filter(Boolean)
    )];
    ids.forEach(this._ensureSubscriptionData);
  };

  _renderSubscription(product, itemCtx = {}) {
    const { website } = this.state;
    const recurringProductId = product?.recurringProductId;
    const pidForData = recurringProductId || null;
    if (pidForData) {
      const entry = this.state.subscriptionData?.[pidForData];
      if (!entry) {
        Promise.resolve().then(() => this._ensureSubscriptionData(pidForData));
        return null;
      }
    }

    const {
      variant: oneTimeOrCurrentVariant,
      quantity: qty = 1,
      customMessage = [],
      frequency: existingFrequency,
      itemSig,
      ssTag
    } = itemCtx;

    const { loading, product: subscribeProduct } = pidForData ? (this.state.subscriptionData?.[pidForData] || {}) : { loading: false, product: null };
    const isSwitchedSubscriptionLine = !!(existingFrequency && ssTag);
    let readOnly = false;
    let frequencyOptions = [];
    if (product?.subscriptionOptions) {
      frequencyOptions = product.subscriptionOptions.split(",").map(opt => {
        const value = opt.trim();
        return { value, label: value };
      });
    } else if (subscribeProduct?.cycle1_billDelay) {
      readOnly = true;
      const days = `${subscribeProduct.cycle1_billDelay} Days`;
      frequencyOptions = [{ value: days, label: days }];
    }

    const saved = this.state.subscriptionSelections?.[pidForData || product?.productId]?.frequency || null;
    const firstOption = frequencyOptions[0]?.value || null;
    const selected = saved ?? firstOption;
    const setSelected = (val) => {
      this.setState(prev => ({
        subscriptionSelections: {
          ...prev.subscriptionSelections,
          [pidForData || product?.productId]: { frequency: val }
        }
      }));
    };

    const findSubVariant = () => findMatchingVariant(subscribeProduct, oneTimeOrCurrentVariant);

    const swapToSubscription = async (checkedEl) => {
      const freq = selected || firstOption;
      if (!freq) {
        Notify.error("No subscription frequency available.");
        if (checkedEl) checkedEl.checked = false;
        return;
      }
      try {
        const subVariant = findSubVariant();
        await Cart.remove(product, oneTimeOrCurrentVariant, customMessage, qty, existingFrequency);

        const newCart = await Cart.add(subscribeProduct, subVariant, customMessage, qty, freq);
        const newSig = ssTags.key(subscribeProduct, subVariant?.variantDetailId, freq);
        const sourcePid = product?.campaignProductId || null;
        const originalVariantId = oneTimeOrCurrentVariant?.variantDetailId || null;
        ssTags.set(newSig, { sourcePid, originalVariantId });

        this.setState({ cart: newCart });
        if (typeof this.props.onUpdatedCart === 'function') this.props.onUpdatedCart(newCart);
      } catch (e) {
        console.error(e);
        Notify.error(e?.message || "Could not switch to subscription.");
        if (checkedEl) checkedEl.checked = false;
      }
    };

    const revertToOneTime = async (checkedEl) => {
      try {
        const sourcePid = ssTag?.sourcePid;
        const originalVariantId = ssTag?.originalVariantId;

        if (!sourcePid) {
          Notify.error("Missing original product reference.");
          if (checkedEl) checkedEl.checked = true;
          return;
        }

        const src = await Backend.getProducts(sourcePid);
        const originalProduct = src?.[0];
        if (!originalProduct) {
          Notify.error("Could not load original product.");
          if (checkedEl) checkedEl.checked = true;
          return;
        }

        const pickOriginalVariant = () => {
          const list = originalProduct?.variants || [];
          if (!list.length) return null;
          if (originalVariantId) {
            const v = list.find(v => v.variantDetailId === Number(originalVariantId));
            if (v) return v;
          }
          if (oneTimeOrCurrentVariant?.title) {
            const byTitle = list.find(v => v.title === oneTimeOrCurrentVariant.title);
            if (byTitle) return byTitle;
          }
          return list[0];
        };
        const originalVariant = pickOriginalVariant();
        const cleanCustom = stripSubsMarkers(customMessage);
        await Cart.remove(product, oneTimeOrCurrentVariant, customMessage, qty, existingFrequency);
        const newCart = await Cart.add(originalProduct, originalVariant, cleanCustom, qty, null);
        if (itemSig) ssTags.del(itemSig);
        this.setState(prev => ({
          cart: newCart,
          subscriptionSelections: {
            ...prev.subscriptionSelections,
            [(product?.recurringProductId || product?.productId)]: { frequency: null }
          }
        }));
        if (typeof this.props.onUpdatedCart === 'function') this.props.onUpdatedCart(newCart);

      } catch (e) {
        console.error(e);
        Notify.error(e?.message || "Could not revert to one-time.");
        if (checkedEl) checkedEl.checked = true;
      }
    };
    const subscribeId = `subscribe-${pidForData || product.campaignProductId || "p"}`;

    const getPriceForVariant = (prod, variantDetailId) => {
      if (!prod) return null;

      const vid = Number(variantDetailId);
      const v = Array.isArray(prod.variants)
        ? prod.variants.find(x => Number(x?.variantDetailId) === vid)
        : null;
      const fromVariant = v?.price != null ? parseFloat(v.price) : null;
      if (!isNaN(fromVariant)) return fromVariant;

      const fromProduct = prod.cycle1_price != null ? parseFloat(prod.cycle1_price) : null;
      return isNaN(fromProduct) ? null : fromProduct;
    };

    let discountText = "";
    let recurringDisplayPrice = 0;
    {
      const oneTimePrice = getPriceForVariant(product, oneTimeOrCurrentVariant?.variantDetailId);
      const subVariant = findSubVariant();
      const recurringPrice = subVariant
        ? getPriceForVariant(subscribeProduct, subVariant.variantDetailId)
        : getPriceForVariant(subscribeProduct, oneTimeOrCurrentVariant?.variantDetailId);

      recurringDisplayPrice = recurringPrice;
      if (oneTimePrice != null && recurringPrice != null && recurringPrice < oneTimePrice) {
        const priceDiff = oneTimePrice - recurringPrice;
        const percent = Math.round((priceDiff / oneTimePrice) * 100);
        discountText = `Save ${percent}%`;
      }
    }

    if (product?.cycle1_price && subscribeProduct?.cycle1_price) {
      const oneTimePrice = parseFloat(product.cycle1_price);
      const recurringPrice = parseFloat(subscribeProduct.cycle1_price);
      if (!isNaN(oneTimePrice) && !isNaN(recurringPrice) && recurringPrice < oneTimePrice) {
        const priceDiff = oneTimePrice - recurringPrice;
        const percent = Math.round((priceDiff / oneTimePrice) * 100);
        discountText = `Save ${percent}%`;
      }
      recurringDisplayPrice = recurringDisplayPrice ?? recurringPrice;
    }

    const subDisplayPrice = `Price: ${Currency.toFormat(recurringDisplayPrice)}`
    const menuSettings = website?.extra?.menu_settings;

    return (
      <div
        className="ss-box"
        style={{
          backgroundColor: menuSettings?.sub_and_save_background_color || "#f9f9f9",
          borderTop: `1px solid ${menuSettings?.sub_and_save_border_color || "#e0e0e0"}`
        }}
      >
        <div className="ss-header">
          <div className="input-checkbox">
            <input
              key={`subcb-${itemSig || ""}-${existingFrequency || ""}-${!!ssTag}`}
              id={subscribeId}
              type="checkbox"
              checked={!!(existingFrequency && ssTag)}
              onChange={(e) => {
                if (e.target.checked && !isSwitchedSubscriptionLine) {
                  swapToSubscription();
                } else if (!e.target.checked && isSwitchedSubscriptionLine) {
                  revertToOneTime();
                }
              }}
            />
            <label
              htmlFor={subscribeId}
              className="ss-checkbox"
            ></label>
          </div>

          <label
            htmlFor={subscribeId}
            className="ss-label"
            style={{ color: menuSettings?.sub_and_save_text_color || "#333" }}
          >
            Subscribe &amp; Save
          </label>

          {discountText && <span
            className="ss-discount-badge"
            style={{
              backgroundColor: menuSettings?.sub_and_save_badge_color || website?.primary_color,
              color: menuSettings?.sub_and_save_badge_text_color || "#fff",
              border: `1px solid ${menuSettings?.sub_and_save_badge_color || website?.primary_color}`
            }}
          >{discountText}</span>}
          <span
            className="ss-price"
            style={{ color: menuSettings?.sub_and_save_price_color || "#222" }}
          >{subDisplayPrice}</span>
        </div>

        {(!pidForData || !loading) && pidForData && frequencyOptions.length > 0 && (
          <div className="ss-frequency">
            <select
              className="ss-frequency-select"
              disabled={readOnly}
              value={selected || ""}
              onChange={(e) => setSelected(e.target.value || null)}
            >
              {frequencyOptions.map((opt) => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </select>
          </div>
        )}
      </div>
    );
  }

  _renderInsureshipWidget() {
    const { insureShipDefChecked, insureShipPopupView } = window?.CURRENT_WEBSITE?.add_ons || {};
    return <div>
      <InsureshipWidget
        cart={this.state.cart}
        updateCart={(data) => {
          this.updateCart(data)
        }}
        insureShipDefChecked={insureShipDefChecked || 0}
        insureShipPopupView={insureShipPopupView}
      />
    </div>
  }

  _getButtonConfigStyles(buttonType) {
    let { website } = this.state, properties = "", colorProperty = "";
    CART_DRAWER_BUTTON_COLOR_CONSTANTS.forEach((item) => {
      const value = website?.extra?.product_page_settings?.[`${buttonType}_${item.key}`];
      if (value) {
        properties += `${item.property}: ${value} !important;`;
        if (item.property === "color") {
          colorProperty = `${item.property}: ${value} !important;`;
        }
      }
    });
    const style = `
      ${colorProperty ? `.co-bag-dropdown .main .btn--${buttonType.replaceAll("_", "-")} .btn__text {
        ${colorProperty}
      }` : ""}
      .s-header .h-bar.pos-fixed .d-header .co-bag-dropdown .main .btn--${buttonType.replaceAll("_", "-")}, .co-bag-dropdown .main .btn--${buttonType.replaceAll("_", "-")} {
        ${properties}
      }
    `
    return properties ? `
      ${style}
      @media (min-width: 991px) {
        ${style}
      }
      @media (min-width: 768px) {
        ${style}
      }
      @media (max-width: 767px) {
        ${style}
      }
    ` : "";
  }

  _renderCartDropdown(primaryButtonStyle) {
    let { website } = this.state;
    const cartSettings = website?.extra?.cart_settings;
    let cart = Cart.getLocalCart()

    const buttons = [
      {
        key: "checkout",
        label: <>Checkout {Currency.toFormat(cart.subtotal)}</>,
        show: website.extra?.product_page_settings?.cart_drawer_checkout ?? true,
        style: website.extra?.product_page_settings?.cart_drawer_checkout_style || "primary",
        configStyles: this._getButtonConfigStyles("cart_drawer_checkout"),
        class: "btn--cart-drawer-checkout",
        position: website.extra?.product_page_settings?.cart_drawer_checkout_position ?? 0,
        onClick: () => {
          const url = website.extra?.product_page_settings?.checkout_url
          if(!url) {
            Notify.error("Checkout url not set, please contact the site owner")
          }else if(window.IS_EDIT_MODE){
            Notify.error("Checkout disabled in edit mode")
          }else if(url) {
            General.setLocationHref(Navigation.getUrl(url))
          }
        }
      },
      {
        key: "view_cart",
        label: "View Cart",
        show: website.extra?.product_page_settings?.cart_drawer_view_cart ?? false,
        style: website.extra?.product_page_settings?.cart_drawer_view_cart_style || "primary",
        configStyles: this._getButtonConfigStyles("cart_drawer_view_cart"),
        class: "btn--cart-drawer-view-cart",
        position: website.extra?.product_page_settings?.cart_drawer_view_cart_position ?? 1,
        onClick: () => {
          General.setLocationHref(Navigation.getCartUrl())
        }
      },
      {
        key: "continue_shopping",
        label: "Continue Shopping",
        show: website.extra?.product_page_settings?.cart_drawer_continue_shopping ?? true,
        style: website.extra?.product_page_settings?.cart_drawer_continue_shopping_style || "secondary",
        configStyles: this._getButtonConfigStyles("cart_drawer_continue_shopping"),
        class: "btn--cart-drawer-continue-shopping",
        position: website.extra?.product_page_settings?.cart_drawer_continue_shopping_position ?? 2,
        onClick: () => this.hideCartDropdown()
      }
    ]

    const buttonRenderKey = JSON.stringify(
      buttons.map(b => [b.key, b.show, b.position])
    );

    const visibleButtons = buttons.filter(btn => btn.show && (btn.condition === undefined || btn.condition)).sort((a, b) => a.position - b.position);
    const drawerTextStyleColor = { color: cartSettings?.cart_drawer_text_color || "#000000" };
    const drawerLineColor = { borderColor: cartSettings?.cart_drawer_line_color || website?.primary_color };
    return (
      <div
        className="main"
        style={{
          backgroundColor: cartSettings?.cart_drawer_background_color || "#fff",
          borderLeft: `2px solid ${cartSettings?.cart_drawer_border_color || "#fff"}`
        }}
      >
        <div
          className="head row m-0 align-items-center justify-content-between"
          style={drawerLineColor}
        >
          <div
            className="title col-auto fs-18"
            style={drawerTextStyleColor}
          >
            <b>My Cart</b> ({Cart.getTotalItemsNo()})
          </div>
          <a
            href="javascript:void(0);"
            className="close"
            onClick={(event) => {
              event.preventDefault();
              this.hideCartDropdown();
            }}
            style={drawerTextStyleColor}
          >
            <span className="material-icons-two-tone">close</span>
          </a>
        </div>

        { this._renderCartThresholdSliderContent(cart?.subtotal) }

        <div className="items">
          { this._renderCartItems(cart) }
          {this.renderRecommendedProducts(cart)}
        </div>
        <div
          className="bottom"
          key={buttonRenderKey}
          style={drawerLineColor}
        >
          {
            this._renderInsureshipWidget()
          }
          {
            visibleButtons.map((btn, i) => {
              return (
                <>
                  {btn.configStyles && <style
                    dangerouslySetInnerHTML={{
                      __html: btn.configStyles
                    }}
                  >
                  </style>}
                  <a
                    key={btn.key}
                    className={`btn btn--${btn.style} ${btn.class} type--uppercase btn--sm${i > 0 ? ' ml-0' : ''}`}
                    style={btn.style === "primary" ? primaryButtonStyle : null}
                    onClick={btn.onClick}
                  >
                    <span className="btn__text">{btn.label}</span>
                  </a>
                </>
              )
            })
          }
        </div>
      </div>
    );
  }

  _renderCartButton() {
    let { cart, data, website } = this.state;

    if(cart == null) {
      return null;
    }

    let isCartEmpty = Cart.getTotalItemsNo() < 1; // set false if value is lessthan 1

    let style = {};
    if (data.primary_button) {
      let settings = data.primary_button.settings;
      if (settings.primary_color) {
        style.color = settings.primary_color;
      }
      if (settings.secondary_color) {
        style.backgroundColor = settings.secondary_color;
      }
      if (settings.tertiary_color) {
        style.borderColor = settings.tertiary_color;
      }
    }

    this._registerCheckoutButtonListener();

    let isCustomCartIcon = website.extra?.menu_settings?.custom_cart_icon;
    let cartIconAction = website.extra?.product_page_settings?.cart_icon_route || "modal"
    const cartQuantity = Cart.getTotalItemsNo();

    return (
      <>
        <div className="co-bag">
          <a
            href="javascript:void(0)"
            className={`nav-checkout ${isCustomCartIcon ? "cc-icon" : ""}`}
            onClick={(event) => {
              event.preventDefault();
              if(cartIconAction === "modal") {
                this.showCartDropdown();
              }else {
                General.setLocationHref(Navigation.getCartUrl())
              }
            }}
          >
            {website.extra?.menu_settings?.custom_cart_icon ? (
              <>
                {
                  getIconType(website.extra?.menu_settings?.custom_cart_icon) === 'svg' ?
                    <img className="m-0" height={25} src={getSVGIcon(website.extra?.menu_settings?.custom_cart_icon)} />
                    :
                    <i
                      className={`${getStandardIcon(website.extra?.menu_settings?.custom_cart_icon)}`}
                    />
                }
                {cartQuantity > 0 && (
                  <span className="custom-cart-quantity-badge">
                    {cartQuantity}
                  </span>
                )}
              </>
            ) : (
              <>
                <span>{cartQuantity}</span>
                <svg
                  viewBox="0 0 30 30"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M24.375 9.14062H20.3906V8.67188C20.3906 5.69531 17.9766 3.28125 15 3.28125C12.0234 3.28125 9.60938 5.69531 9.60938 8.67188V9.14062H5.625C5.10645 9.14062 4.6875 9.55957 4.6875 10.0781V25.7812C4.6875 26.2998 5.10645 26.7188 5.625 26.7188H24.375C24.8936 26.7188 25.3125 26.2998 25.3125 25.7812V10.0781C25.3125 9.55957 24.8936 9.14062 24.375 9.14062ZM18.2812 9.14062H11.7188V8.67188C11.7188 6.8584 13.1865 5.39062 15 5.39062C16.8135 5.39062 18.2812 6.8584 18.2812 8.67188V9.14062Z"
                    fill="#333333"
                  />
                </svg>
              </>
            )}
          </a>
          <div className="co-bag-dropdown hide">
            <>{this._renderCartDropdown(style)}</>
            <div className="co-bag-dropdown-bg"></div>
          </div>
        </div>
      </>
    );
  }

  _generateCustomBlockData(data, id) {
    return {
      extra: {
        [id]: data?.website?.extra?.menu_settings?.[id]
      }
    }
  }

  _renderMenuButtons(data, editable, hamburgerHeader) {
    let primaryWebsiteColor = data.website.primary_color;
    if (data.primary_button && data.primary_button.settings.msc_enabled) {
      data.primary_button.settings.quinary_color = primaryWebsiteColor;
      data.primary_button.settings.senary_color = primaryWebsiteColor;
    }
    if (data.secondary_button && data.secondary_button.settings.msc_enabled) {
      data.secondary_button.settings.quaternary_color = primaryWebsiteColor;
      data.secondary_button.settings.senary_color = primaryWebsiteColor;
    }
    let areTwoButtons = data.primary_button && data.secondary_button;
    const primaryButtonId = data.primary_button?.id || null, secondaryButtonId = data.secondary_button?.id || null;
    return (
      <div className={`${hamburgerHeader ? "" : "bar__module"} ${areTwoButtons ? "two-buttons" : ""}`}>
        <Button
          data={data.secondary_button}
          type="secondary"
          size="small"
          cssClass="menu-button"
          editable={editable}
          secondaryColorsTitle="Sticky Nav Bar Colors"
          secondaryColorsSubtitle="Displayed when on solid background color (such as white)"
          ccLinkType={"menu"}
          onUpdated={(button) => {
            data.secondary_button = button;
            this._update(data);
          }}
          blockData={this._generateCustomBlockData(data, secondaryButtonId)}
          onBlockUpdated={(obj) => {
            this._updateExtraMenuSettings(secondaryButtonId, obj?.extra?.[secondaryButtonId])
          }}
        />
        <Button
          data={data.primary_button}
          type="primary"
          size="small"
          cssClass="menu-button"
          editable={editable}
          secondaryColorsTitle="Sticky Nav Bar Colors"
          secondaryColorsSubtitle="Displayed when on solid background color (such as white)"
          ccLinkType={"menu"}
          onUpdated={(button) => {
            data.primary_button = button;
            this._update(data);
          }}
          blockData={this._generateCustomBlockData(data, primaryButtonId)}
          onBlockUpdated={(obj) => {
            this._updateExtraMenuSettings(primaryButtonId, obj?.extra?.[primaryButtonId])
          }}
        />
        <span className="co-btn">
          {this._renderCartButton()}
        </span>
        {data.primary_button && (
          <style
            dangerouslySetInnerHTML={{
              __html: `
            .s-header .h-bar.pos-fixed .d-header .btn--primary {
              background-color: ${data.primary_button.settings.quinary_color} !important;;
              border-color: ${data.primary_button.settings.senary_color} !important;;
            }
            .s-header .h-bar.pos-fixed .d-header .btn--primary > span {
              color: ${data.primary_button.settings.quaternary_color} !important;
            }
          `,
            }}
          />
        )}
        {data.secondary_button && (
          <style
            dangerouslySetInnerHTML={{
              __html: `
            .s-header .h-bar.pos-fixed .d-header .btn--secondary {
              background-color: ${data.secondary_button.settings.quinary_color} !important;;
              border-color: ${data.secondary_button.settings.senary_color} !important;;
            }
            .s-header .h-bar.pos-fixed .d-header .btn--secondary > span {
              color: ${data.secondary_button.settings.quaternary_color} !important;;
            }
            @media (max-width: 767px){
              #menu1 .btn--secondary {
                background-color: ${data.secondary_button.settings.quinary_color} !important;;
                border-color: ${data.secondary_button.settings.senary_color} !important;;
              }
              #menu1 .btn--secondary > span {
                color: ${data.secondary_button.settings.quaternary_color} !important;;
              }
            }
          `,
            }}
          />
        )}
      </div>
    );
  }

  async _handleSearch(searchTerm) {
    if (searchTerm.trim().length < 2) {
      this.setState({ searchResults: [] });
      return;
    }

    this.setState({ searching: true });

    try {
      const productIds = await Backend.useProductQuery(searchTerm);
      if (!productIds || productIds.length === 0) {
        this.setState({ searchResults: [], searching: false });
        return;
      }
      const productIdList = productIds.slice(0, 3);

      const products = await Backend.getProducts(productIdList.join(","));
      this.setState({ searchResults: products || [], searching: false });
    } catch (error) {
      console.error("Search error:", error);
      this.setState({ searchResults: [], searching: false });
    }
  }

  _renderSearchBar() {
    const { searchTerm, website, searchBarFocused } = this.state;

    if (!website.extra?.menu_settings?.show_search_bar) return null;

    const placeholder = website.extra?.menu_settings?.search_bar_placeholder ?? "Search Products...";

    const isExpanded = searchBarFocused || !!searchTerm;

    return (
      <div
        className={`menu-search ${isExpanded ? "expanded" : ""}`}
      >
        <input
          type="text"
          placeholder={placeholder}
          value={searchTerm || ""}
          onChange={(e) => {
            const value = e.target.value;
            this.setState({ searchTerm: value });
            this._handleSearch(value);
          }}
          onFocus={() => this.setState({ searchBarFocused: true })}
          onBlur={() => {
            if (!this.state.searchTerm) {
              this.setState({ searchBarFocused: false });
            }
          }}
        />
        {
          !isExpanded ?
            <i
              className="material-icons"
              onClick={() => {
                if (!this.state.searchBarFocused) {
                  this.setState({searchBarFocused: true})
                }
              }}
            >search</i>
            :
            <i
              className="material-icons"
              onClick={() => {
                this.setState({
                  searchBarFocused: false,
                  searchTerm: "",
                  searchResults: []
                });
              }}
            >
              close
            </i>
        }
      </div>
    );
  }

  _renderMenuLogo(data, editable, hamburgerHeader) {
    let logoCenterInColumn;
    if (data.logo_position === "center" && !hamburgerHeader) {
      logoCenterInColumn = true;
    }

    let homepageSlug = window.CURRENT_WEBSITE.homepage_slug || ""
    const homePageUrl = Navigation.getUrl(`/${homepageSlug}`)
    return (
      <div className="bar__module s-logos">
        <a
          className={`logo-link ${logoCenterInColumn ? "mx-auto" : ""}`}
          href={homePageUrl}
          onClick={() => {
            General.setLocationHref(homePageUrl)
          }}
        >
          {this._renderPrimaryLogo(data, editable)}
          {this._renderSecondaryLogo(data, editable)}
        </a>
      </div>
    );
  }
  _renderDeleteModal() {
    const { deleteNavItem, deleteNavIndex, deleteData, showDeleteModal } = this.state;
    return (
      <DeleteModal
        showModal={showDeleteModal}
        onDelete={() => {
          this.setState({ showDeleteModal: false });
          Backend.updateCCPageLinks(General.clone(deleteNavItem), "menu")
          deleteData.nav_items.splice(deleteNavIndex, 1);
          this._update(deleteData);
        }}
        onHide={() => {
          this.setState({ showDeleteModal: false });
        }}
        modalHeader={"Delete Menu Link"}
        htmlContent={<h4>
          Are you sure you want to delete this menu link? <br></br>
        </h4>}
      />
    );
  }
  _renderSiteWideNotice() {
    let { data } = this.state;

    if (!data || !data.website.demo) {
      return null;
    }

    return (
      <div
        className="main-container site-wide-notice bar ptb-10px bg--secondary "
        style={{ backgroundColor: "#fa6160" }}
      >
        <div class="container">
          <div
            class="row align-items-center justify-content-center flex-nowrap"
            style={{ color: "rgb(255, 255, 255)" }}
          >
            <div class="col-auto h-25-px">
              <i class="icon icon--sm icon-Warning fs-25-px"></i>
            </div>
            <div class="col p-0 col-md-auto">
              <p className="lh-25-px">This website is in demo mode</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  _handleClosePromoBar() {
    if (typeof window !== "undefined") {
      sessionStorage.setItem("promoBarClosed", "true");
    }

    this.setState({ promoClosed: true });
  }

  _renderPromoBar() {
    let{
      website,
      promoIndex,
      promoClosed
    } = this.state;

    if(!website.extra?.menu_settings?.show_promo_bar) return null;

    if(website.extra?.menu_settings?.close_button && promoClosed) return null;

    const promoMessages = website.extra?.menu_settings?.promo_messages || [];
    const promoBarStyle = website.extra?.menu_settings?.promo_bar_style || "single";

    const backgroundColor = website.extra?.menu_settings?.promo_bar_background_color || website.primary_color
    const textColor = website.extra?.menu_settings?.promo_bar_text_color || "rgb(255, 255, 255)"

    const animationStyle = website.extra?.menu_settings?.promo_bar_rotate_animation || "flip-in-x"

    if (promoBarStyle === "rotate" && promoMessages.length > 1 && !this.rotateInterval) {
      this.rotateInterval = setInterval(() => {
        this.setState((prevState) => ({
          promoIndex: (prevState.promoIndex + 1) % promoMessages.length
        }));
      }, website.extra?.menu_settings?.promo_bar_rotate_interval || 3000);
    }

    let content = null;

    if (promoBarStyle === "single") {
      content = <p className="lh-25-px" style={{ color: textColor }}>{promoMessages[0]?.text}</p>;
    } else if (promoBarStyle === "rotate") {
      content = <p key={promoIndex} className={`lh-25-px ${animationStyle}`} style={{ color: textColor }}>{promoMessages[promoIndex]?.text}</p>;
    } else if (promoBarStyle === "continuous") {
      content = (
        <div className="promo-bar-wrapper overflow-hidden">
          <div className="promo-bar d-inline-block">
            {promoMessages.map((msg, i) => (
              <span key={i} className="promo-message" style={{ color: textColor }}>{msg.text}</span>
            ))}
          </div>
        </div>
      );
    }

    return (
      <div
        className="main-container bar ptb-10px bg--primary "
        style={{ backgroundColor }}
      >
        <div className="container">
          <div
            className="row align-items-center justify-content-center flex-nowrap"
          >
            <div className="col p-0 col-md-auto text-center">
              {content}
            </div>
            {
              website.extra?.menu_settings?.close_button &&
              <div className="col-auto promo-bar-close-wrapper">
                <a
                  type="button"
                  className="promo-bar-close-btn"
                  onClick={this._handleClosePromoBar}
                  aria-label="Close promo bar"
                  href="#"
                  style={{ color: textColor }}
                >
                  ×
                </a>
              </div>
            }
          </div>
        </div>
        <style jsx>
          {`
            .promo-bar {
              animation: scroll-left
              ${website.extra?.menu_settings?.promo_bar_continuous_speed || 20}s
              linear infinite;
            }

            @keyframes scroll-left {
              0% {
                transform: translateX(100%);
              }
              100% {
                transform: translateX(-100%);
              }
            }

            .main-container.bar {
              position: relative;
            }

            .promo-bar-close-wrapper {
              position: absolute;
              top: 50%;
              right: 15px;
              transform: translateY(-50%);
              display: flex;
              align-items: center;
              justify-content: center;
              pointer-events: auto;
            }

            .promo-bar-close-btn {
              background: transparent;
              border: none;
              font-size: 30px;
              font-weight: 600;
              line-height: 1;
              cursor: pointer;
              opacity: 0.85;
              transition: opacity 0.2s ease, transform 0.15s ease;
              text-decoration: none !important;
            }

            .promo-bar-close-btn:hover {
              opacity: 1;
              transform: scale(1.1);
            }

            .promo-bar-close-btn:focus {
              outline: none;
            }
          `}
        </style>
      </div>
    );
  }

  _renderMenu() {
    let { cart, data, editable, website } = this.state;

    let hamburgerHeader = data.style === "hamburger";
    let isHamburgerMenuStyleDropdown = website.extra?.menu_settings?.hamburger_menu_style === "dropdown";

    // Show Hamburger Icon/Button only when the Nav Items, or Primary Button or Secondary Button avaialble
    let showHamburgerMenu =
      data.nav_items.length > 0 || data.primary_button || data.secondary_button;

    let homepageSlug = window.CURRENT_WEBSITE.homepage_slug || ""
    let homepagePath = Navigation.getUrl(`/${homepageSlug}`)
    const customHamburgerIcon = website.extra?.menu_settings?.custom_hamburger_icon
    const svgIcon = getIconType(customHamburgerIcon) === 'svg'
    return (
      <>
        {General._renderMenuStyle(data.settings, website)}

        {!website.hide_menu && !this.props.hideMenu && (
          <>
            {General.updateScroll()}
            {General.updateToggleClass()}

            {/* starts : Hamburger Header */}
            {hamburgerHeader && (
              <>
                <nav class="bar bar-toggle bar--transparent bg--dark h-hamburger">
                  <div class="container">
                    <div class="row align-items-center">
                      <div class="col-6">
                        {this._renderMenuLogo(data, editable, hamburgerHeader)}
                      </div>
                      {showHamburgerMenu && (
                        <div class="col-6 d-flex justify-content-end">

                          {website.extra?.menu_settings?.show_search_bar && (
                            <div className="col-auto d-flex align-items-center">
                              {this._renderSearchBar()}
                            </div>
                          )}
                          <div class="bar__module">
                            {!isHamburgerMenuStyleDropdown &&
                              <div class="modal-instance pull-right">
                                <a class={`modal-trigger menu-toggle ${svgIcon ? "d-flex justify-content-center align-items-center" : ""}`} href="#">
                                  {
                                    customHamburgerIcon ?
                                      <>
                                        {
                                          svgIcon ?
                                            <img className="m-0" style={{ height: "1.78571429em", margin: "auto 1px" }} src={getSVGIcon(customHamburgerIcon)} />
                                          :
                                            <i
                                              className={`${getStandardIcon(customHamburgerIcon)}`}
                                            />
                                        }
                                      </>
                                    :
                                      <>
                                        <i className="stack-interface stack-menu"></i>
                                      </>
                                  }
                                </a>

                                <div class="modal-container menu-fullscreen">
                                  <div
                                    class="modal-content"
                                    data-width="100%"
                                    data-height="100%"
                                  >
                                    <div class="d-flex flex-column justify-content-center mh-100p text-center">
                                      <div className="nav-block">
                                        {this._renderMenuNavItems(
                                          data,
                                          editable,
                                          hamburgerHeader
                                        )}
                                      </div>
                                      <div>
                                        {this._renderMenuButtons(
                                          data,
                                          editable,
                                          hamburgerHeader
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>

                              </div>
                            }
                            {isHamburgerMenuStyleDropdown &&
                              <>
                                <div class="dropdown ham-dd">
                                  <span class="dropdown__trigger menu-toggle">
                                    {
                                      website.extra?.menu_settings?.custom_hamburger_icon ?
                                        <>
                                          <i
                                            className={`${website.extra?.menu_settings?.custom_hamburger_icon}`}
                                          />
                                        </>
                                      :
                                        <>
                                          <i className="stack-interface stack-menu"></i>
                                        </>
                                    }
                                  </span>
                                  <div class="dropdown__container">
                                    <div class="container">
                                      <div class="row">
                                        <div class="col-md-3 col-lg-2 dropdown__content">
                                          <ul class="menu-vertical">
                                            {this._renderNavItems(data.nav_items, hamburgerHeader)}
                                          </ul>
                                          <div className="separate">
                                            {this._renderMenuButtons(data, editable)}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </>
                            }
                          </div>
                        </div>
                      )}

                      {this._renderEditable(editable)}
                    </div>
                  </div>
                </nav>
              </>
            )}
            {/* end : Hamburger Header */}

            {/* starts : Mobile Header */}
            {!hamburgerHeader && (
              <div className="m-header bar bar--sm visible-xs bar--mobile-sticky">
                <div className="container">
                  <div className="row align-items-center">
                    <div className="col-2 s-logos">
                      <a className="logo-link" href={homepagePath} onClick={() => { General.setLocationHref(homepagePath) }}>
                        {this._renderPrimaryLogo(data, editable)}
                        {this._renderSecondaryLogo(data, editable)}
                      </a>
                    </div>

                    <div className="col-10">
                      <div className="row align-items-center justify-content-end">
                        {website.extra?.menu_settings?.show_search_bar && (
                          <div className="col-auto pr-2">
                            {this._renderSearchBar()}
                          </div>
                        )}

                        {cart && (
                          <div className="pl-0 col-auto">
                            {this._renderCartButton()}
                          </div>
                        )}

                        {showHamburgerMenu && (
                          <div className="pl-0 col-auto">
                            <a
                              href={Navigation.getUrl(homepagePath)}
                              onClick={() => {
                                General.setLocationHref(Navigation.getUrl(homepagePath))
                              }}
                              className={`hamburger-toggle ${website.extra?.menu_settings?.custom_hamburger_icon ? "ch-icon" : ""}`}
                              data-toggle-class="#menu1;hidden-xs hidden-sm"
                            >
                              {
                                website.extra?.menu_settings?.custom_hamburger_icon ?
                                  <>
                                    {
                                      getIconType(website.extra?.menu_settings?.custom_hamburger_icon) === 'svg' ?
                                        <img className="m-0" height={24} src={getSVGIcon(website.extra?.menu_settings?.custom_hamburger_icon)} />
                                      :
                                        <i
                                          className={`${getStandardIcon(website.extra?.menu_settings?.custom_hamburger_icon)}`}
                                        />
                                    }
                                  </>
                                :
                                  <>
                                    <span></span><span></span><span></span>
                                  </>
                              }
                            </a>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {/* end : Mobile Header */}

            {/* starts : Desktop Header */}
            {!hamburgerHeader && (
              <nav
                id="menu1"
                className={`d-header bar bar-1 hidden-xs bar--transparent logo_position_${data.logo_position}`}
              >
                <div className="container">
                  <div className="row align-items-center">
                    {this._renderMenuContent(data, editable)}
                  </div>
                </div>
              </nav>
            )}
            {/* end : Desktop Header */}

          </>
        )}
      </>
    );
  }

  render() {
    let { cart, data, editable, website } = this.state;

    let navBarParentClassName = this.props.hidePrimaryNavBar
      ? "secondary-nav-bar"
      : "";
    let navBarClassName = this.props.hidePrimaryNavBar
      ? "pos-fixed"
      : "bar--absolute";
    let navBarProps = this.props.hidePrimaryNavBar
      ? {}
      : {
          "data-scroll-class": "366px:pos-fixed",
        };

    const promoBarPosition = website.extra?.menu_settings?.promo_bar_position || "above"

    return (
      <>
        <div
          className={`s-header ${navBarParentClassName} ${
            data.website?.demo ? "site-wide-notice-on" : ""
          } ${
            data.website.hide_menu || this.props.hideMenu ? "header-off" : ""
          }`}
        >
          <div
            className={`h-bar bar bar--transparent p-0 ${navBarClassName}`}
            {...navBarProps}
          >
            {this._renderSiteWideNotice(editable)}
            {promoBarPosition === "above" && this._renderPromoBar()}
            <div className="nav-container">{this._renderMenu(editable)}</div>
            {promoBarPosition === "below" && this._renderPromoBar()}
            <div
              className="search-results-wrapper">
              <SearchResults
                searchTerm={this.state.searchTerm}
                searchResults={this.state.searchResults}
                searching={this.state.searching}
                onAddToCartPressed={(product, variant, customMessage, quantity) =>
                  this.props.onAddToCartPressed(product, variant, customMessage, quantity)}
              />
            </div>
          </div>
        </div>
        {this._renderDeleteModal()}
      </>
    );
  }
}

const DEFAULT_PRIMARY_BUTTON = {
  settings: {
    primary_color: "#ffffff",
  },
  badge_settings: {
    primary_color: "#ffffff",
    secondary_color: null,
    tertiary_color: "#007ec1",
  },
  title: "Primary Button Text",
  url: "/",
  badge: null,
  open_in_new_tab: false,
};

const DEFAULT_SECONDARY_BUTTON = {
  settings: {
    secondary_color: "transparent",
  },
  badge_settings: {
    primary_color: "#ffffff",
    secondary_color: null,
    tertiary_color: "#007ec1",
  },
  title: "Secondary Button Text",
  url: "/",
  badge: null,
  open_in_new_tab: false,
};

const UNRESERVER_CART_ITEM_UUIDS = [];
